webpackJsonp([154382131621592],{

/***/ 49:
/***/ (function(module, exports) {

	function _assertThisInitialized(self) {
	  if (self === void 0) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }
	
	  return self;
	}
	
	module.exports = _assertThisInitialized;

/***/ }),

/***/ 50:
/***/ (function(module, exports) {

	function _extends() {
	  module.exports = _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];
	
	      for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }
	
	    return target;
	  };
	
	  return _extends.apply(this, arguments);
	}
	
	module.exports = _extends;

/***/ }),

/***/ 51:
/***/ (function(module, exports) {

	function _inheritsLoose(subClass, superClass) {
	  subClass.prototype = Object.create(superClass.prototype);
	  subClass.prototype.constructor = subClass;
	  subClass.__proto__ = superClass;
	}
	
	module.exports = _inheritsLoose;

/***/ }),

/***/ 52:
/***/ (function(module, exports) {

	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : {
	    "default": obj
	  };
	}
	
	module.exports = _interopRequireDefault;

/***/ }),

/***/ 53:
/***/ (function(module, exports) {

	function _objectWithoutPropertiesLoose(source, excluded) {
	  if (source == null) return {};
	  var target = {};
	  var sourceKeys = Object.keys(source);
	  var key, i;
	
	  for (i = 0; i < sourceKeys.length; i++) {
	    key = sourceKeys[i];
	    if (excluded.indexOf(key) >= 0) continue;
	    target[key] = source[key];
	  }
	
	  return target;
	}
	
	module.exports = _objectWithoutPropertiesLoose;

/***/ }),

/***/ 11:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	  Copyright (c) 2017 Jed Watson.
	  Licensed under the MIT License (MIT), see
	  http://jedwatson.github.io/classnames
	*/
	/* global define */
	
	(function () {
		'use strict';
	
		var hasOwn = {}.hasOwnProperty;
	
		function classNames () {
			var classes = [];
	
			for (var i = 0; i < arguments.length; i++) {
				var arg = arguments[i];
				if (!arg) continue;
	
				var argType = typeof arg;
	
				if (argType === 'string' || argType === 'number') {
					classes.push(arg);
				} else if (Array.isArray(arg) && arg.length) {
					var inner = classNames.apply(null, arg);
					if (inner) {
						classes.push(inner);
					}
				} else if (argType === 'object') {
					for (var key in arg) {
						if (hasOwn.call(arg, key) && arg[key]) {
							classes.push(key);
						}
					}
				}
			}
	
			return classes.join(' ');
		}
	
		if (typeof module !== 'undefined' && module.exports) {
			classNames.default = classNames;
			module.exports = classNames;
		} else if (true) {
			// register as 'classnames', consistent with npm package name
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
				return classNames;
			}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else {
			window.classNames = classNames;
		}
	}());


/***/ }),

/***/ 242:
/***/ (function(module, exports, __webpack_require__) {

	var QueryHandler = __webpack_require__(244);
	var each = __webpack_require__(118).each;
	
	/**
	 * Represents a single media query, manages it's state and registered handlers for this query
	 *
	 * @constructor
	 * @param {string} query the media query string
	 * @param {boolean} [isUnconditional=false] whether the media query should run regardless of whether the conditions are met. Primarily for helping older browsers deal with mobile-first design
	 */
	function MediaQuery(query, isUnconditional) {
	    this.query = query;
	    this.isUnconditional = isUnconditional;
	    this.handlers = [];
	    this.mql = window.matchMedia(query);
	
	    var self = this;
	    this.listener = function(mql) {
	        // Chrome passes an MediaQueryListEvent object, while other browsers pass MediaQueryList directly
	        self.mql = mql.currentTarget || mql;
	        self.assess();
	    };
	    this.mql.addListener(this.listener);
	}
	
	MediaQuery.prototype = {
	
	    constuctor : MediaQuery,
	
	    /**
	     * add a handler for this query, triggering if already active
	     *
	     * @param {object} handler
	     * @param {function} handler.match callback for when query is activated
	     * @param {function} [handler.unmatch] callback for when query is deactivated
	     * @param {function} [handler.setup] callback for immediate execution when a query handler is registered
	     * @param {boolean} [handler.deferSetup=false] should the setup callback be deferred until the first time the handler is matched?
	     */
	    addHandler : function(handler) {
	        var qh = new QueryHandler(handler);
	        this.handlers.push(qh);
	
	        this.matches() && qh.on();
	    },
	
	    /**
	     * removes the given handler from the collection, and calls it's destroy methods
	     *
	     * @param {object || function} handler the handler to remove
	     */
	    removeHandler : function(handler) {
	        var handlers = this.handlers;
	        each(handlers, function(h, i) {
	            if(h.equals(handler)) {
	                h.destroy();
	                return !handlers.splice(i,1); //remove from array and exit each early
	            }
	        });
	    },
	
	    /**
	     * Determine whether the media query should be considered a match
	     *
	     * @return {Boolean} true if media query can be considered a match, false otherwise
	     */
	    matches : function() {
	        return this.mql.matches || this.isUnconditional;
	    },
	
	    /**
	     * Clears all handlers and unbinds events
	     */
	    clear : function() {
	        each(this.handlers, function(handler) {
	            handler.destroy();
	        });
	        this.mql.removeListener(this.listener);
	        this.handlers.length = 0; //clear array
	    },
	
	    /*
	        * Assesses the query, turning on all handlers if it matches, turning them off if it doesn't match
	        */
	    assess : function() {
	        var action = this.matches() ? 'on' : 'off';
	
	        each(this.handlers, function(handler) {
	            handler[action]();
	        });
	    }
	};
	
	module.exports = MediaQuery;


/***/ }),

/***/ 243:
/***/ (function(module, exports, __webpack_require__) {

	var MediaQuery = __webpack_require__(242);
	var Util = __webpack_require__(118);
	var each = Util.each;
	var isFunction = Util.isFunction;
	var isArray = Util.isArray;
	
	/**
	 * Allows for registration of query handlers.
	 * Manages the query handler's state and is responsible for wiring up browser events
	 *
	 * @constructor
	 */
	function MediaQueryDispatch () {
	    if(!window.matchMedia) {
	        throw new Error('matchMedia not present, legacy browsers require a polyfill');
	    }
	
	    this.queries = {};
	    this.browserIsIncapable = !window.matchMedia('only all').matches;
	}
	
	MediaQueryDispatch.prototype = {
	
	    constructor : MediaQueryDispatch,
	
	    /**
	     * Registers a handler for the given media query
	     *
	     * @param {string} q the media query
	     * @param {object || Array || Function} options either a single query handler object, a function, or an array of query handlers
	     * @param {function} options.match fired when query matched
	     * @param {function} [options.unmatch] fired when a query is no longer matched
	     * @param {function} [options.setup] fired when handler first triggered
	     * @param {boolean} [options.deferSetup=false] whether setup should be run immediately or deferred until query is first matched
	     * @param {boolean} [shouldDegrade=false] whether this particular media query should always run on incapable browsers
	     */
	    register : function(q, options, shouldDegrade) {
	        var queries         = this.queries,
	            isUnconditional = shouldDegrade && this.browserIsIncapable;
	
	        if(!queries[q]) {
	            queries[q] = new MediaQuery(q, isUnconditional);
	        }
	
	        //normalise to object in an array
	        if(isFunction(options)) {
	            options = { match : options };
	        }
	        if(!isArray(options)) {
	            options = [options];
	        }
	        each(options, function(handler) {
	            if (isFunction(handler)) {
	                handler = { match : handler };
	            }
	            queries[q].addHandler(handler);
	        });
	
	        return this;
	    },
	
	    /**
	     * unregisters a query and all it's handlers, or a specific handler for a query
	     *
	     * @param {string} q the media query to target
	     * @param {object || function} [handler] specific handler to unregister
	     */
	    unregister : function(q, handler) {
	        var query = this.queries[q];
	
	        if(query) {
	            if(handler) {
	                query.removeHandler(handler);
	            }
	            else {
	                query.clear();
	                delete this.queries[q];
	            }
	        }
	
	        return this;
	    }
	};
	
	module.exports = MediaQueryDispatch;


/***/ }),

/***/ 244:
/***/ (function(module, exports) {

	/**
	 * Delegate to handle a media query being matched and unmatched.
	 *
	 * @param {object} options
	 * @param {function} options.match callback for when the media query is matched
	 * @param {function} [options.unmatch] callback for when the media query is unmatched
	 * @param {function} [options.setup] one-time callback triggered the first time a query is matched
	 * @param {boolean} [options.deferSetup=false] should the setup callback be run immediately, rather than first time query is matched?
	 * @constructor
	 */
	function QueryHandler(options) {
	    this.options = options;
	    !options.deferSetup && this.setup();
	}
	
	QueryHandler.prototype = {
	
	    constructor : QueryHandler,
	
	    /**
	     * coordinates setup of the handler
	     *
	     * @function
	     */
	    setup : function() {
	        if(this.options.setup) {
	            this.options.setup();
	        }
	        this.initialised = true;
	    },
	
	    /**
	     * coordinates setup and triggering of the handler
	     *
	     * @function
	     */
	    on : function() {
	        !this.initialised && this.setup();
	        this.options.match && this.options.match();
	    },
	
	    /**
	     * coordinates the unmatch event for the handler
	     *
	     * @function
	     */
	    off : function() {
	        this.options.unmatch && this.options.unmatch();
	    },
	
	    /**
	     * called when a handler is to be destroyed.
	     * delegates to the destroy or unmatch callbacks, depending on availability.
	     *
	     * @function
	     */
	    destroy : function() {
	        this.options.destroy ? this.options.destroy() : this.off();
	    },
	
	    /**
	     * determines equality by reference.
	     * if object is supplied compare options, if function, compare match callback
	     *
	     * @function
	     * @param {object || function} [target] the target for comparison
	     */
	    equals : function(target) {
	        return this.options === target || this.options.match === target;
	    }
	
	};
	
	module.exports = QueryHandler;


/***/ }),

/***/ 118:
/***/ (function(module, exports) {

	/**
	 * Helper function for iterating over a collection
	 *
	 * @param collection
	 * @param fn
	 */
	function each(collection, fn) {
	    var i      = 0,
	        length = collection.length,
	        cont;
	
	    for(i; i < length; i++) {
	        cont = fn(collection[i], i);
	        if(cont === false) {
	            break; //allow early exit
	        }
	    }
	}
	
	/**
	 * Helper function for determining whether target object is an array
	 *
	 * @param target the object under test
	 * @return {Boolean} true if array, false otherwise
	 */
	function isArray(target) {
	    return Object.prototype.toString.apply(target) === '[object Array]';
	}
	
	/**
	 * Helper function for determining whether target object is a function
	 *
	 * @param target the object under test
	 * @return {Boolean} true if function, false otherwise
	 */
	function isFunction(target) {
	    return typeof target === 'function';
	}
	
	module.exports = {
	    isFunction : isFunction,
	    isArray : isArray,
	    each : each
	};


/***/ }),

/***/ 245:
/***/ (function(module, exports, __webpack_require__) {

	var MediaQueryDispatch = __webpack_require__(243);
	module.exports = new MediaQueryDispatch();


/***/ }),

/***/ 83:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(52);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(51));
	
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(49));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(53));
	
	var _extends2 = _interopRequireDefault(__webpack_require__(50));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var logDeprecationNotice = function logDeprecationNotice(prop, replacement) {
	  if (true) {
	    return;
	  }
	
	  console.log("\n    The \"" + prop + "\" prop is now deprecated and will be removed in the next major version\n    of \"gatsby-image\".\n    ");
	
	  if (replacement) {
	    console.log("Please use " + replacement + " instead of \"" + prop + "\".");
	  }
	}; // Handle legacy props during their deprecation phase
	
	
	var convertProps = function convertProps(props) {
	  var convertedProps = (0, _extends2.default)({}, props);
	  var resolutions = convertedProps.resolutions,
	      sizes = convertedProps.sizes,
	      critical = convertedProps.critical;
	
	  if (resolutions) {
	    convertedProps.fixed = resolutions;
	    delete convertedProps.resolutions;
	  }
	
	  if (sizes) {
	    convertedProps.fluid = sizes;
	    delete convertedProps.sizes;
	  }
	
	  if (critical) {
	    logDeprecationNotice("critical", "the native \"loading\" attribute");
	    convertedProps.loading = "eager";
	  }
	
	  return convertedProps;
	}; // Cache if we've seen an image before so we don't bother with
	// lazy-loading & fading in on subsequent mounts.
	
	
	var imageCache = Object.create({});
	
	var inImageCache = function inImageCache(props) {
	  var convertedProps = convertProps(props); // Find src
	
	  var src = convertedProps.fluid ? convertedProps.fluid.src : convertedProps.fixed.src;
	  return imageCache[src] || false;
	};
	
	var activateCacheForImage = function activateCacheForImage(props) {
	  var convertedProps = convertProps(props); // Find src
	
	  var src = convertedProps.fluid ? convertedProps.fluid.src : convertedProps.fixed.src;
	  imageCache[src] = true;
	}; // Native lazy-loading support: https://addyosmani.com/blog/lazy-loading/
	
	
	var hasNativeLazyLoadSupport = typeof HTMLImageElement !== "undefined" && "loading" in HTMLImageElement.prototype;
	var isBrowser = typeof window !== "undefined";
	var hasIOSupport = isBrowser && window.IntersectionObserver;
	var io;
	var listeners = new WeakMap();
	
	function getIO() {
	  if (typeof io === "undefined" && typeof window !== "undefined" && window.IntersectionObserver) {
	    io = new window.IntersectionObserver(function (entries) {
	      entries.forEach(function (entry) {
	        if (listeners.has(entry.target)) {
	          var cb = listeners.get(entry.target); // Edge doesn't currently support isIntersecting, so also test for an intersectionRatio > 0
	
	          if (entry.isIntersecting || entry.intersectionRatio > 0) {
	            io.unobserve(entry.target);
	            listeners.delete(entry.target);
	            cb();
	          }
	        }
	      });
	    }, {
	      rootMargin: "200px"
	    });
	  }
	
	  return io;
	}
	
	var listenToIntersections = function listenToIntersections(el, cb) {
	  var observer = getIO();
	
	  if (observer) {
	    observer.observe(el);
	    listeners.set(el, cb);
	  }
	
	  return function () {
	    observer.unobserve(el);
	    listeners.delete(el);
	  };
	};
	
	var noscriptImg = function noscriptImg(props) {
	  // Check if prop exists before adding each attribute to the string output below to prevent
	  // HTML validation issues caused by empty values like width="" and height=""
	  var src = props.src ? "src=\"" + props.src + "\" " : "src=\"\" "; // required attribute
	
	  var sizes = props.sizes ? "sizes=\"" + props.sizes + "\" " : "";
	  var srcSetWebp = props.srcSetWebp ? "<source type='image/webp' srcset=\"" + props.srcSetWebp + "\" " + sizes + "/>" : "";
	  var srcSet = props.srcSet ? "srcset=\"" + props.srcSet + "\" " : "";
	  var title = props.title ? "title=\"" + props.title + "\" " : "";
	  var alt = props.alt ? "alt=\"" + props.alt + "\" " : "alt=\"\" "; // required attribute
	
	  var width = props.width ? "width=\"" + props.width + "\" " : "";
	  var height = props.height ? "height=\"" + props.height + "\" " : "";
	  var crossOrigin = props.crossOrigin ? "crossorigin=\"" + props.crossOrigin + "\" " : "";
	  var loading = props.loading ? "loading=\"" + props.loading + "\" " : "";
	  return "<picture>" + srcSetWebp + "<img " + loading + width + height + sizes + srcSet + src + alt + title + crossOrigin + "style=\"position:absolute;top:0;left:0;opacity:1;width:100%;height:100%;object-fit:cover;object-position:center\"/></picture>";
	};
	
	var Img = _react.default.forwardRef(function (props, ref) {
	  var sizes = props.sizes,
	      srcSet = props.srcSet,
	      src = props.src,
	      style = props.style,
	      onLoad = props.onLoad,
	      onError = props.onError,
	      loading = props.loading,
	      otherProps = (0, _objectWithoutPropertiesLoose2.default)(props, ["sizes", "srcSet", "src", "style", "onLoad", "onError", "loading"]);
	  return _react.default.createElement("img", (0, _extends2.default)({
	    sizes: sizes,
	    srcSet: srcSet,
	    src: src
	  }, otherProps, {
	    onLoad: onLoad,
	    onError: onError,
	    ref: ref,
	    loading: loading,
	    style: (0, _extends2.default)({
	      position: "absolute",
	      top: 0,
	      left: 0,
	      width: "100%",
	      height: "100%",
	      objectFit: "cover",
	      objectPosition: "center"
	    }, style)
	  }));
	});
	
	Img.propTypes = {
	  style: _propTypes.default.object,
	  onError: _propTypes.default.func,
	  onLoad: _propTypes.default.func
	};
	
	var Image =
	/*#__PURE__*/
	function (_React$Component) {
	  (0, _inheritsLoose2.default)(Image, _React$Component);
	
	  function Image(props) {
	    var _this;
	
	    _this = _React$Component.call(this, props) || this; // If this image has already been loaded before then we can assume it's
	    // already in the browser cache so it's cheap to just show directly.
	
	    _this.seenBefore = isBrowser && inImageCache(props);
	    _this.addNoScript = !(props.critical && !props.fadeIn);
	    _this.useIOSupport = !hasNativeLazyLoadSupport && hasIOSupport && !props.critical && !_this.seenBefore;
	    var isVisible = props.critical || isBrowser && (hasNativeLazyLoadSupport || !_this.useIOSupport);
	    _this.state = {
	      isVisible: isVisible,
	      imgLoaded: false,
	      imgCached: false,
	      fadeIn: !_this.seenBefore && props.fadeIn
	    };
	    _this.imageRef = _react.default.createRef();
	    _this.handleImageLoaded = _this.handleImageLoaded.bind((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)));
	    _this.handleRef = _this.handleRef.bind((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)));
	    return _this;
	  }
	
	  var _proto = Image.prototype;
	
	  _proto.componentDidMount = function componentDidMount() {
	    if (this.state.isVisible && typeof this.props.onStartLoad === "function") {
	      this.props.onStartLoad({
	        wasCached: inImageCache(this.props)
	      });
	    }
	
	    if (this.props.critical) {
	      var img = this.imageRef.current;
	
	      if (img && img.complete) {
	        this.handleImageLoaded();
	      }
	    }
	  };
	
	  _proto.componentWillUnmount = function componentWillUnmount() {
	    if (this.cleanUpListeners) {
	      this.cleanUpListeners();
	    }
	  }; // Specific to IntersectionObserver based lazy-load support
	
	
	  _proto.handleRef = function handleRef(ref) {
	    var _this2 = this;
	
	    if (this.useIOSupport && ref) {
	      this.cleanUpListeners = listenToIntersections(ref, function () {
	        var imageInCache = inImageCache(_this2.props);
	
	        if (!_this2.state.isVisible && typeof _this2.props.onStartLoad === "function") {
	          _this2.props.onStartLoad({
	            wasCached: imageInCache
	          });
	        } // imgCached and imgLoaded must update after isVisible,
	        // Once isVisible is true, imageRef becomes accessible, which imgCached needs access to.
	        // imgLoaded and imgCached are in a 2nd setState call to be changed together,
	        // avoiding initiating unnecessary animation frames from style changes.
	
	
	        _this2.setState({
	          isVisible: true
	        }, function () {
	          return _this2.setState({
	            imgLoaded: imageInCache,
	            // `currentSrc` should be a string, but can be `undefined` in IE,
	            // !! operator validates the value is not undefined/null/""
	            imgCached: !!_this2.imageRef.current.currentSrc
	          });
	        });
	      });
	    }
	  };
	
	  _proto.handleImageLoaded = function handleImageLoaded() {
	    activateCacheForImage(this.props);
	    this.setState({
	      imgLoaded: true
	    });
	
	    if (this.props.onLoad) {
	      this.props.onLoad();
	    }
	  };
	
	  _proto.render = function render() {
	    var _convertProps = convertProps(this.props),
	        title = _convertProps.title,
	        alt = _convertProps.alt,
	        className = _convertProps.className,
	        _convertProps$style = _convertProps.style,
	        style = _convertProps$style === void 0 ? {} : _convertProps$style,
	        _convertProps$imgStyl = _convertProps.imgStyle,
	        imgStyle = _convertProps$imgStyl === void 0 ? {} : _convertProps$imgStyl,
	        _convertProps$placeho = _convertProps.placeholderStyle,
	        placeholderStyle = _convertProps$placeho === void 0 ? {} : _convertProps$placeho,
	        placeholderClassName = _convertProps.placeholderClassName,
	        fluid = _convertProps.fluid,
	        fixed = _convertProps.fixed,
	        backgroundColor = _convertProps.backgroundColor,
	        durationFadeIn = _convertProps.durationFadeIn,
	        Tag = _convertProps.Tag,
	        itemProp = _convertProps.itemProp,
	        loading = _convertProps.loading;
	
	    var shouldReveal = this.state.fadeIn === false || this.state.imgLoaded;
	    var shouldFadeIn = this.state.fadeIn === true && !this.state.imgCached;
	    var imageStyle = (0, _extends2.default)({
	      opacity: shouldReveal ? 1 : 0,
	      transition: shouldFadeIn ? "opacity " + durationFadeIn + "ms" : "none"
	    }, imgStyle);
	    var bgColor = typeof backgroundColor === "boolean" ? "lightgray" : backgroundColor;
	    var delayHideStyle = {
	      transitionDelay: durationFadeIn + "ms"
	    };
	    var imagePlaceholderStyle = (0, _extends2.default)({
	      opacity: this.state.imgLoaded ? 0 : 1
	    }, shouldFadeIn && delayHideStyle, imgStyle, placeholderStyle);
	    var placeholderImageProps = {
	      title: title,
	      alt: !this.state.isVisible ? alt : "",
	      style: imagePlaceholderStyle,
	      className: placeholderClassName
	    };
	
	    if (fluid) {
	      var image = fluid;
	      return _react.default.createElement(Tag, {
	        className: (className ? className : "") + " gatsby-image-wrapper",
	        style: (0, _extends2.default)({
	          position: "relative",
	          overflow: "hidden"
	        }, style),
	        ref: this.handleRef,
	        key: "fluid-" + JSON.stringify(image.srcSet)
	      }, _react.default.createElement(Tag, {
	        style: {
	          width: "100%",
	          paddingBottom: 100 / image.aspectRatio + "%"
	        }
	      }), bgColor && _react.default.createElement(Tag, {
	        title: title,
	        style: (0, _extends2.default)({
	          backgroundColor: bgColor,
	          position: "absolute",
	          top: 0,
	          bottom: 0,
	          opacity: !this.state.imgLoaded ? 1 : 0,
	          right: 0,
	          left: 0
	        }, shouldFadeIn && delayHideStyle)
	      }), image.base64 && _react.default.createElement(Img, (0, _extends2.default)({
	        src: image.base64
	      }, placeholderImageProps)), image.tracedSVG && _react.default.createElement(Img, (0, _extends2.default)({
	        src: image.tracedSVG
	      }, placeholderImageProps)), this.state.isVisible && _react.default.createElement("picture", null, image.srcSetWebp && _react.default.createElement("source", {
	        type: "image/webp",
	        srcSet: image.srcSetWebp,
	        sizes: image.sizes
	      }), _react.default.createElement(Img, {
	        alt: alt,
	        title: title,
	        sizes: image.sizes,
	        src: image.src,
	        crossOrigin: this.props.crossOrigin,
	        srcSet: image.srcSet,
	        style: imageStyle,
	        ref: this.imageRef,
	        onLoad: this.handleImageLoaded,
	        onError: this.props.onError,
	        itemProp: itemProp,
	        loading: loading
	      })), this.addNoScript && _react.default.createElement("noscript", {
	        dangerouslySetInnerHTML: {
	          __html: noscriptImg((0, _extends2.default)({
	            alt: alt,
	            title: title,
	            loading: loading
	          }, image))
	        }
	      }));
	    }
	
	    if (fixed) {
	      var _image = fixed;
	      var divStyle = (0, _extends2.default)({
	        position: "relative",
	        overflow: "hidden",
	        display: "inline-block",
	        width: _image.width,
	        height: _image.height
	      }, style);
	
	      if (style.display === "inherit") {
	        delete divStyle.display;
	      }
	
	      return _react.default.createElement(Tag, {
	        className: (className ? className : "") + " gatsby-image-wrapper",
	        style: divStyle,
	        ref: this.handleRef,
	        key: "fixed-" + JSON.stringify(_image.srcSet)
	      }, bgColor && _react.default.createElement(Tag, {
	        title: title,
	        style: (0, _extends2.default)({
	          backgroundColor: bgColor,
	          width: _image.width,
	          opacity: !this.state.imgLoaded ? 1 : 0,
	          height: _image.height
	        }, shouldFadeIn && delayHideStyle)
	      }), _image.base64 && _react.default.createElement(Img, (0, _extends2.default)({
	        src: _image.base64
	      }, placeholderImageProps)), _image.tracedSVG && _react.default.createElement(Img, (0, _extends2.default)({
	        src: _image.tracedSVG
	      }, placeholderImageProps)), this.state.isVisible && _react.default.createElement("picture", null, _image.srcSetWebp && _react.default.createElement("source", {
	        type: "image/webp",
	        srcSet: _image.srcSetWebp,
	        sizes: _image.sizes
	      }), _react.default.createElement(Img, {
	        alt: alt,
	        title: title,
	        width: _image.width,
	        height: _image.height,
	        sizes: _image.sizes,
	        src: _image.src,
	        crossOrigin: this.props.crossOrigin,
	        srcSet: _image.srcSet,
	        style: imageStyle,
	        ref: this.imageRef,
	        onLoad: this.handleImageLoaded,
	        onError: this.props.onError,
	        itemProp: itemProp,
	        loading: loading
	      })), this.addNoScript && _react.default.createElement("noscript", {
	        dangerouslySetInnerHTML: {
	          __html: noscriptImg((0, _extends2.default)({
	            alt: alt,
	            title: title,
	            loading: loading
	          }, _image))
	        }
	      }));
	    }
	
	    return null;
	  };
	
	  return Image;
	}(_react.default.Component);
	
	Image.defaultProps = {
	  fadeIn: true,
	  durationFadeIn: 500,
	  alt: "",
	  Tag: "div",
	  // We set it to `lazy` by default because it's best to default to a performant
	  // setting and let the user "opt out" to `eager`
	  loading: "lazy"
	};
	
	var fixedObject = _propTypes.default.shape({
	  width: _propTypes.default.number.isRequired,
	  height: _propTypes.default.number.isRequired,
	  src: _propTypes.default.string.isRequired,
	  srcSet: _propTypes.default.string.isRequired,
	  base64: _propTypes.default.string,
	  tracedSVG: _propTypes.default.string,
	  srcWebp: _propTypes.default.string,
	  srcSetWebp: _propTypes.default.string
	});
	
	var fluidObject = _propTypes.default.shape({
	  aspectRatio: _propTypes.default.number.isRequired,
	  src: _propTypes.default.string.isRequired,
	  srcSet: _propTypes.default.string.isRequired,
	  sizes: _propTypes.default.string.isRequired,
	  base64: _propTypes.default.string,
	  tracedSVG: _propTypes.default.string,
	  srcWebp: _propTypes.default.string,
	  srcSetWebp: _propTypes.default.string
	});
	
	Image.propTypes = {
	  resolutions: fixedObject,
	  sizes: fluidObject,
	  fixed: fixedObject,
	  fluid: fluidObject,
	  fadeIn: _propTypes.default.bool,
	  durationFadeIn: _propTypes.default.number,
	  title: _propTypes.default.string,
	  alt: _propTypes.default.string,
	  className: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.object]),
	  // Support Glamor's css prop.
	  critical: _propTypes.default.bool,
	  crossOrigin: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.bool]),
	  style: _propTypes.default.object,
	  imgStyle: _propTypes.default.object,
	  placeholderStyle: _propTypes.default.object,
	  placeholderClassName: _propTypes.default.string,
	  backgroundColor: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.bool]),
	  onLoad: _propTypes.default.func,
	  onError: _propTypes.default.func,
	  onStartLoad: _propTypes.default.func,
	  Tag: _propTypes.default.string,
	  itemProp: _propTypes.default.string,
	  loading: _propTypes.default.oneOf(["auto", "lazy", "eager"])
	};
	var _default = Image;
	exports.default = _default;

/***/ }),

/***/ 322:
/***/ (function(module, exports, __webpack_require__) {

	var camel2hyphen = __webpack_require__(349);
	
	var isDimension = function (feature) {
	  var re = /[height|width]$/;
	  return re.test(feature);
	};
	
	var obj2mq = function (obj) {
	  var mq = '';
	  var features = Object.keys(obj);
	  features.forEach(function (feature, index) {
	    var value = obj[feature];
	    feature = camel2hyphen(feature);
	    // Add px to dimension features
	    if (isDimension(feature) && typeof value === 'number') {
	      value = value + 'px';
	    }
	    if (value === true) {
	      mq += feature;
	    } else if (value === false) {
	      mq += 'not ' + feature;
	    } else {
	      mq += '(' + feature + ': ' + value + ')';
	    }
	    if (index < features.length-1) {
	      mq += ' and '
	    }
	  });
	  return mq;
	};
	
	var json2mq = function (query) {
	  var mq = '';
	  if (typeof query === 'string') {
	    return query;
	  }
	  // Handling array of media queries
	  if (query instanceof Array) {
	    query.forEach(function (q, index) {
	      mq += obj2mq(q);
	      if (index < query.length-1) {
	        mq += ', '
	      }
	    });
	    return mq;
	  }
	  // Handling single media query
	  return obj2mq(query);
	};
	
	module.exports = json2mq;

/***/ }),

/***/ 323:
/***/ (function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {/**
	 * lodash (Custom Build) <https://lodash.com/>
	 * Build: `lodash modularize exports="npm" -o ./`
	 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
	 * Released under MIT license <https://lodash.com/license>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 */
	
	/** Used as the `TypeError` message for "Functions" methods. */
	var FUNC_ERROR_TEXT = 'Expected a function';
	
	/** Used as references for various `Number` constants. */
	var NAN = 0 / 0;
	
	/** `Object#toString` result references. */
	var symbolTag = '[object Symbol]';
	
	/** Used to match leading and trailing whitespace. */
	var reTrim = /^\s+|\s+$/g;
	
	/** Used to detect bad signed hexadecimal string values. */
	var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
	
	/** Used to detect binary string values. */
	var reIsBinary = /^0b[01]+$/i;
	
	/** Used to detect octal string values. */
	var reIsOctal = /^0o[0-7]+$/i;
	
	/** Built-in method references without a dependency on `root`. */
	var freeParseInt = parseInt;
	
	/** Detect free variable `global` from Node.js. */
	var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
	
	/** Detect free variable `self`. */
	var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
	
	/** Used as a reference to the global object. */
	var root = freeGlobal || freeSelf || Function('return this')();
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objectToString = objectProto.toString;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMax = Math.max,
	    nativeMin = Math.min;
	
	/**
	 * Gets the timestamp of the number of milliseconds that have elapsed since
	 * the Unix epoch (1 January 1970 00:00:00 UTC).
	 *
	 * @static
	 * @memberOf _
	 * @since 2.4.0
	 * @category Date
	 * @returns {number} Returns the timestamp.
	 * @example
	 *
	 * _.defer(function(stamp) {
	 *   console.log(_.now() - stamp);
	 * }, _.now());
	 * // => Logs the number of milliseconds it took for the deferred invocation.
	 */
	var now = function() {
	  return root.Date.now();
	};
	
	/**
	 * Creates a debounced function that delays invoking `func` until after `wait`
	 * milliseconds have elapsed since the last time the debounced function was
	 * invoked. The debounced function comes with a `cancel` method to cancel
	 * delayed `func` invocations and a `flush` method to immediately invoke them.
	 * Provide `options` to indicate whether `func` should be invoked on the
	 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
	 * with the last arguments provided to the debounced function. Subsequent
	 * calls to the debounced function return the result of the last `func`
	 * invocation.
	 *
	 * **Note:** If `leading` and `trailing` options are `true`, `func` is
	 * invoked on the trailing edge of the timeout only if the debounced function
	 * is invoked more than once during the `wait` timeout.
	 *
	 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
	 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
	 *
	 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
	 * for details over the differences between `_.debounce` and `_.throttle`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Function
	 * @param {Function} func The function to debounce.
	 * @param {number} [wait=0] The number of milliseconds to delay.
	 * @param {Object} [options={}] The options object.
	 * @param {boolean} [options.leading=false]
	 *  Specify invoking on the leading edge of the timeout.
	 * @param {number} [options.maxWait]
	 *  The maximum time `func` is allowed to be delayed before it's invoked.
	 * @param {boolean} [options.trailing=true]
	 *  Specify invoking on the trailing edge of the timeout.
	 * @returns {Function} Returns the new debounced function.
	 * @example
	 *
	 * // Avoid costly calculations while the window size is in flux.
	 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
	 *
	 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
	 * jQuery(element).on('click', _.debounce(sendMail, 300, {
	 *   'leading': true,
	 *   'trailing': false
	 * }));
	 *
	 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
	 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
	 * var source = new EventSource('/stream');
	 * jQuery(source).on('message', debounced);
	 *
	 * // Cancel the trailing debounced invocation.
	 * jQuery(window).on('popstate', debounced.cancel);
	 */
	function debounce(func, wait, options) {
	  var lastArgs,
	      lastThis,
	      maxWait,
	      result,
	      timerId,
	      lastCallTime,
	      lastInvokeTime = 0,
	      leading = false,
	      maxing = false,
	      trailing = true;
	
	  if (typeof func != 'function') {
	    throw new TypeError(FUNC_ERROR_TEXT);
	  }
	  wait = toNumber(wait) || 0;
	  if (isObject(options)) {
	    leading = !!options.leading;
	    maxing = 'maxWait' in options;
	    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
	    trailing = 'trailing' in options ? !!options.trailing : trailing;
	  }
	
	  function invokeFunc(time) {
	    var args = lastArgs,
	        thisArg = lastThis;
	
	    lastArgs = lastThis = undefined;
	    lastInvokeTime = time;
	    result = func.apply(thisArg, args);
	    return result;
	  }
	
	  function leadingEdge(time) {
	    // Reset any `maxWait` timer.
	    lastInvokeTime = time;
	    // Start the timer for the trailing edge.
	    timerId = setTimeout(timerExpired, wait);
	    // Invoke the leading edge.
	    return leading ? invokeFunc(time) : result;
	  }
	
	  function remainingWait(time) {
	    var timeSinceLastCall = time - lastCallTime,
	        timeSinceLastInvoke = time - lastInvokeTime,
	        result = wait - timeSinceLastCall;
	
	    return maxing ? nativeMin(result, maxWait - timeSinceLastInvoke) : result;
	  }
	
	  function shouldInvoke(time) {
	    var timeSinceLastCall = time - lastCallTime,
	        timeSinceLastInvoke = time - lastInvokeTime;
	
	    // Either this is the first call, activity has stopped and we're at the
	    // trailing edge, the system time has gone backwards and we're treating
	    // it as the trailing edge, or we've hit the `maxWait` limit.
	    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
	      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
	  }
	
	  function timerExpired() {
	    var time = now();
	    if (shouldInvoke(time)) {
	      return trailingEdge(time);
	    }
	    // Restart the timer.
	    timerId = setTimeout(timerExpired, remainingWait(time));
	  }
	
	  function trailingEdge(time) {
	    timerId = undefined;
	
	    // Only invoke if we have `lastArgs` which means `func` has been
	    // debounced at least once.
	    if (trailing && lastArgs) {
	      return invokeFunc(time);
	    }
	    lastArgs = lastThis = undefined;
	    return result;
	  }
	
	  function cancel() {
	    if (timerId !== undefined) {
	      clearTimeout(timerId);
	    }
	    lastInvokeTime = 0;
	    lastArgs = lastCallTime = lastThis = timerId = undefined;
	  }
	
	  function flush() {
	    return timerId === undefined ? result : trailingEdge(now());
	  }
	
	  function debounced() {
	    var time = now(),
	        isInvoking = shouldInvoke(time);
	
	    lastArgs = arguments;
	    lastThis = this;
	    lastCallTime = time;
	
	    if (isInvoking) {
	      if (timerId === undefined) {
	        return leadingEdge(lastCallTime);
	      }
	      if (maxing) {
	        // Handle invocations in a tight loop.
	        timerId = setTimeout(timerExpired, wait);
	        return invokeFunc(lastCallTime);
	      }
	    }
	    if (timerId === undefined) {
	      timerId = setTimeout(timerExpired, wait);
	    }
	    return result;
	  }
	  debounced.cancel = cancel;
	  debounced.flush = flush;
	  return debounced;
	}
	
	/**
	 * Checks if `value` is the
	 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(_.noop);
	 * // => true
	 *
	 * _.isObject(null);
	 * // => false
	 */
	function isObject(value) {
	  var type = typeof value;
	  return !!value && (type == 'object' || type == 'function');
	}
	
	/**
	 * Checks if `value` is object-like. A value is object-like if it's not `null`
	 * and has a `typeof` result of "object".
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 * @example
	 *
	 * _.isObjectLike({});
	 * // => true
	 *
	 * _.isObjectLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isObjectLike(_.noop);
	 * // => false
	 *
	 * _.isObjectLike(null);
	 * // => false
	 */
	function isObjectLike(value) {
	  return !!value && typeof value == 'object';
	}
	
	/**
	 * Checks if `value` is classified as a `Symbol` primitive or object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
	 * @example
	 *
	 * _.isSymbol(Symbol.iterator);
	 * // => true
	 *
	 * _.isSymbol('abc');
	 * // => false
	 */
	function isSymbol(value) {
	  return typeof value == 'symbol' ||
	    (isObjectLike(value) && objectToString.call(value) == symbolTag);
	}
	
	/**
	 * Converts `value` to a number.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to process.
	 * @returns {number} Returns the number.
	 * @example
	 *
	 * _.toNumber(3.2);
	 * // => 3.2
	 *
	 * _.toNumber(Number.MIN_VALUE);
	 * // => 5e-324
	 *
	 * _.toNumber(Infinity);
	 * // => Infinity
	 *
	 * _.toNumber('3.2');
	 * // => 3.2
	 */
	function toNumber(value) {
	  if (typeof value == 'number') {
	    return value;
	  }
	  if (isSymbol(value)) {
	    return NAN;
	  }
	  if (isObject(value)) {
	    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
	    value = isObject(other) ? (other + '') : other;
	  }
	  if (typeof value != 'string') {
	    return value === 0 ? value : +value;
	  }
	  value = value.replace(reTrim, '');
	  var isBinary = reIsBinary.test(value);
	  return (isBinary || reIsOctal.test(value))
	    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
	    : (reIsBadHex.test(value) ? NAN : +value);
	}
	
	module.exports = debounce;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),

/***/ 90:
/***/ (function(module, exports) {

	// shim for using process in browser
	var process = module.exports = {};
	
	// cached from whatever global is present so that test runners that stub it
	// don't break things.  But we need to wrap it in a try catch in case it is
	// wrapped in strict mode code which doesn't define any globals.  It's inside a
	// function because try/catches deoptimize in certain engines.
	
	var cachedSetTimeout;
	var cachedClearTimeout;
	
	function defaultSetTimout() {
	    throw new Error('setTimeout has not been defined');
	}
	function defaultClearTimeout () {
	    throw new Error('clearTimeout has not been defined');
	}
	(function () {
	    try {
	        if (typeof setTimeout === 'function') {
	            cachedSetTimeout = setTimeout;
	        } else {
	            cachedSetTimeout = defaultSetTimout;
	        }
	    } catch (e) {
	        cachedSetTimeout = defaultSetTimout;
	    }
	    try {
	        if (typeof clearTimeout === 'function') {
	            cachedClearTimeout = clearTimeout;
	        } else {
	            cachedClearTimeout = defaultClearTimeout;
	        }
	    } catch (e) {
	        cachedClearTimeout = defaultClearTimeout;
	    }
	} ())
	function runTimeout(fun) {
	    if (cachedSetTimeout === setTimeout) {
	        //normal enviroments in sane situations
	        return setTimeout(fun, 0);
	    }
	    // if setTimeout wasn't available but was latter defined
	    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
	        cachedSetTimeout = setTimeout;
	        return setTimeout(fun, 0);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedSetTimeout(fun, 0);
	    } catch(e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
	            return cachedSetTimeout.call(null, fun, 0);
	        } catch(e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
	            return cachedSetTimeout.call(this, fun, 0);
	        }
	    }
	
	
	}
	function runClearTimeout(marker) {
	    if (cachedClearTimeout === clearTimeout) {
	        //normal enviroments in sane situations
	        return clearTimeout(marker);
	    }
	    // if clearTimeout wasn't available but was latter defined
	    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
	        cachedClearTimeout = clearTimeout;
	        return clearTimeout(marker);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedClearTimeout(marker);
	    } catch (e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
	            return cachedClearTimeout.call(null, marker);
	        } catch (e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
	            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
	            return cachedClearTimeout.call(this, marker);
	        }
	    }
	
	
	
	}
	var queue = [];
	var draining = false;
	var currentQueue;
	var queueIndex = -1;
	
	function cleanUpNextTick() {
	    if (!draining || !currentQueue) {
	        return;
	    }
	    draining = false;
	    if (currentQueue.length) {
	        queue = currentQueue.concat(queue);
	    } else {
	        queueIndex = -1;
	    }
	    if (queue.length) {
	        drainQueue();
	    }
	}
	
	function drainQueue() {
	    if (draining) {
	        return;
	    }
	    var timeout = runTimeout(cleanUpNextTick);
	    draining = true;
	
	    var len = queue.length;
	    while(len) {
	        currentQueue = queue;
	        queue = [];
	        while (++queueIndex < len) {
	            if (currentQueue) {
	                currentQueue[queueIndex].run();
	            }
	        }
	        queueIndex = -1;
	        len = queue.length;
	    }
	    currentQueue = null;
	    draining = false;
	    runClearTimeout(timeout);
	}
	
	process.nextTick = function (fun) {
	    var args = new Array(arguments.length - 1);
	    if (arguments.length > 1) {
	        for (var i = 1; i < arguments.length; i++) {
	            args[i - 1] = arguments[i];
	        }
	    }
	    queue.push(new Item(fun, args));
	    if (queue.length === 1 && !draining) {
	        runTimeout(drainQueue);
	    }
	};
	
	// v8 likes predictible objects
	function Item(fun, array) {
	    this.fun = fun;
	    this.array = array;
	}
	Item.prototype.run = function () {
	    this.fun.apply(null, this.array);
	};
	process.title = 'browser';
	process.browser = true;
	process.env = {};
	process.argv = [];
	process.version = ''; // empty string to avoid regexp issues
	process.versions = {};
	
	function noop() {}
	
	process.on = noop;
	process.addListener = noop;
	process.once = noop;
	process.off = noop;
	process.removeListener = noop;
	process.removeAllListeners = noop;
	process.emit = noop;
	process.prependListener = noop;
	process.prependOnceListener = noop;
	
	process.listeners = function (name) { return [] }
	
	process.binding = function (name) {
	    throw new Error('process.binding is not supported');
	};
	
	process.cwd = function () { return '/' };
	process.chdir = function (dir) {
	    throw new Error('process.chdir is not supported');
	};
	process.umask = function() { return 0; };


/***/ }),

/***/ 334:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.NextArrow = exports.PrevArrow = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _classnames = _interopRequireDefault(__webpack_require__(11));
	
	var _innerSliderUtils = __webpack_require__(48);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	var PrevArrow =
	/*#__PURE__*/
	function (_React$PureComponent) {
	  _inherits(PrevArrow, _React$PureComponent);
	
	  function PrevArrow() {
	    _classCallCheck(this, PrevArrow);
	
	    return _possibleConstructorReturn(this, _getPrototypeOf(PrevArrow).apply(this, arguments));
	  }
	
	  _createClass(PrevArrow, [{
	    key: "clickHandler",
	    value: function clickHandler(options, e) {
	      if (e) {
	        e.preventDefault();
	      }
	
	      this.props.clickHandler(options, e);
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var prevClasses = {
	        "slick-arrow": true,
	        "slick-prev": true
	      };
	      var prevHandler = this.clickHandler.bind(this, {
	        message: "previous"
	      });
	
	      if (!this.props.infinite && (this.props.currentSlide === 0 || this.props.slideCount <= this.props.slidesToShow)) {
	        prevClasses["slick-disabled"] = true;
	        prevHandler = null;
	      }
	
	      var prevArrowProps = {
	        key: "0",
	        "data-role": "none",
	        className: (0, _classnames.default)(prevClasses),
	        style: {
	          display: "block"
	        },
	        onClick: prevHandler
	      };
	      var customProps = {
	        currentSlide: this.props.currentSlide,
	        slideCount: this.props.slideCount
	      };
	      var prevArrow;
	
	      if (this.props.prevArrow) {
	        prevArrow = _react.default.cloneElement(this.props.prevArrow, _objectSpread({}, prevArrowProps, customProps));
	      } else {
	        prevArrow = _react.default.createElement("button", _extends({
	          key: "0",
	          type: "button"
	        }, prevArrowProps), " ", "Previous");
	      }
	
	      return prevArrow;
	    }
	  }]);
	
	  return PrevArrow;
	}(_react.default.PureComponent);
	
	exports.PrevArrow = PrevArrow;
	
	var NextArrow =
	/*#__PURE__*/
	function (_React$PureComponent2) {
	  _inherits(NextArrow, _React$PureComponent2);
	
	  function NextArrow() {
	    _classCallCheck(this, NextArrow);
	
	    return _possibleConstructorReturn(this, _getPrototypeOf(NextArrow).apply(this, arguments));
	  }
	
	  _createClass(NextArrow, [{
	    key: "clickHandler",
	    value: function clickHandler(options, e) {
	      if (e) {
	        e.preventDefault();
	      }
	
	      this.props.clickHandler(options, e);
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var nextClasses = {
	        "slick-arrow": true,
	        "slick-next": true
	      };
	      var nextHandler = this.clickHandler.bind(this, {
	        message: "next"
	      });
	
	      if (!(0, _innerSliderUtils.canGoNext)(this.props)) {
	        nextClasses["slick-disabled"] = true;
	        nextHandler = null;
	      }
	
	      var nextArrowProps = {
	        key: "1",
	        "data-role": "none",
	        className: (0, _classnames.default)(nextClasses),
	        style: {
	          display: "block"
	        },
	        onClick: nextHandler
	      };
	      var customProps = {
	        currentSlide: this.props.currentSlide,
	        slideCount: this.props.slideCount
	      };
	      var nextArrow;
	
	      if (this.props.nextArrow) {
	        nextArrow = _react.default.cloneElement(this.props.nextArrow, _objectSpread({}, nextArrowProps, customProps));
	      } else {
	        nextArrow = _react.default.createElement("button", _extends({
	          key: "1",
	          type: "button"
	        }, nextArrowProps), " ", "Next");
	      }
	
	      return nextArrow;
	    }
	  }]);
	
	  return NextArrow;
	}(_react.default.PureComponent);
	
	exports.NextArrow = NextArrow;

/***/ }),

/***/ 335:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var defaultProps = {
	  accessibility: true,
	  adaptiveHeight: false,
	  afterChange: null,
	  appendDots: function appendDots(dots) {
	    return _react.default.createElement("ul", {
	      style: {
	        display: "block"
	      }
	    }, dots);
	  },
	  arrows: true,
	  autoplay: false,
	  autoplaySpeed: 3000,
	  beforeChange: null,
	  centerMode: false,
	  centerPadding: "50px",
	  className: "",
	  cssEase: "ease",
	  customPaging: function customPaging(i) {
	    return _react.default.createElement("button", null, i + 1);
	  },
	  dots: false,
	  dotsClass: "slick-dots",
	  draggable: true,
	  easing: "linear",
	  edgeFriction: 0.35,
	  fade: false,
	  focusOnSelect: false,
	  infinite: true,
	  initialSlide: 0,
	  lazyLoad: null,
	  nextArrow: null,
	  onEdge: null,
	  onInit: null,
	  onLazyLoadError: null,
	  onReInit: null,
	  pauseOnDotsHover: false,
	  pauseOnFocus: false,
	  pauseOnHover: true,
	  prevArrow: null,
	  responsive: null,
	  rows: 1,
	  rtl: false,
	  slide: "div",
	  slidesPerRow: 1,
	  slidesToScroll: 1,
	  slidesToShow: 1,
	  speed: 500,
	  swipe: true,
	  swipeEvent: null,
	  swipeToSlide: false,
	  touchMove: true,
	  touchThreshold: 5,
	  useCSS: true,
	  useTransform: true,
	  variableWidth: false,
	  vertical: false,
	  waitForAnimate: true
	};
	var _default = defaultProps;
	exports.default = _default;

/***/ }),

/***/ 336:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Dots = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _classnames = _interopRequireDefault(__webpack_require__(11));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	var getDotCount = function getDotCount(spec) {
	  var dots;
	
	  if (spec.infinite) {
	    dots = Math.ceil(spec.slideCount / spec.slidesToScroll);
	  } else {
	    dots = Math.ceil((spec.slideCount - spec.slidesToShow) / spec.slidesToScroll) + 1;
	  }
	
	  return dots;
	};
	
	var Dots =
	/*#__PURE__*/
	function (_React$PureComponent) {
	  _inherits(Dots, _React$PureComponent);
	
	  function Dots() {
	    _classCallCheck(this, Dots);
	
	    return _possibleConstructorReturn(this, _getPrototypeOf(Dots).apply(this, arguments));
	  }
	
	  _createClass(Dots, [{
	    key: "clickHandler",
	    value: function clickHandler(options, e) {
	      // In Autoplay the focus stays on clicked button even after transition
	      // to next slide. That only goes away by click somewhere outside
	      e.preventDefault();
	      this.props.clickHandler(options);
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this = this;
	
	      var dotCount = getDotCount({
	        slideCount: this.props.slideCount,
	        slidesToScroll: this.props.slidesToScroll,
	        slidesToShow: this.props.slidesToShow,
	        infinite: this.props.infinite
	      }); // Apply join & split to Array to pre-fill it for IE8
	      //
	      // Credit: http://stackoverflow.com/a/13735425/1849458
	
	      var _this$props = this.props,
	          onMouseEnter = _this$props.onMouseEnter,
	          onMouseOver = _this$props.onMouseOver,
	          onMouseLeave = _this$props.onMouseLeave;
	      var mouseEvents = {
	        onMouseEnter: onMouseEnter,
	        onMouseOver: onMouseOver,
	        onMouseLeave: onMouseLeave
	      };
	      var dots = Array.apply(null, Array(dotCount + 1).join("0").split("")).map(function (x, i) {
	        var leftBound = i * _this.props.slidesToScroll;
	        var rightBound = i * _this.props.slidesToScroll + (_this.props.slidesToScroll - 1);
	        var className = (0, _classnames.default)({
	          "slick-active": _this.props.currentSlide >= leftBound && _this.props.currentSlide <= rightBound
	        });
	        var dotOptions = {
	          message: "dots",
	          index: i,
	          slidesToScroll: _this.props.slidesToScroll,
	          currentSlide: _this.props.currentSlide
	        };
	
	        var onClick = _this.clickHandler.bind(_this, dotOptions);
	
	        return _react.default.createElement("li", {
	          key: i,
	          className: className
	        }, _react.default.cloneElement(_this.props.customPaging(i), {
	          onClick: onClick
	        }));
	      });
	      return _react.default.cloneElement(this.props.appendDots(dots), _objectSpread({
	        className: this.props.dotsClass
	      }, mouseEvents));
	    }
	  }]);
	
	  return Dots;
	}(_react.default.PureComponent);
	
	exports.Dots = Dots;

/***/ }),

/***/ 337:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _slider = _interopRequireDefault(__webpack_require__(340));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _default = _slider.default;
	exports.default = _default;

/***/ }),

/***/ 338:
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var initialState = {
	  animating: false,
	  autoplaying: null,
	  currentDirection: 0,
	  currentLeft: null,
	  currentSlide: 0,
	  direction: 1,
	  dragging: false,
	  edgeDragged: false,
	  initialized: false,
	  lazyLoadedList: [],
	  listHeight: null,
	  listWidth: null,
	  scrolling: false,
	  slideCount: null,
	  slideHeight: null,
	  slideWidth: null,
	  swipeLeft: null,
	  swiped: false,
	  // used by swipeEvent. differentites between touch and swipe.
	  swiping: false,
	  touchObject: {
	    startX: 0,
	    startY: 0,
	    curX: 0,
	    curY: 0
	  },
	  trackStyle: {},
	  trackWidth: 0
	};
	var _default = initialState;
	exports.default = _default;

/***/ }),

/***/ 339:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.InnerSlider = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _reactDom = _interopRequireDefault(__webpack_require__(47));
	
	var _initialState = _interopRequireDefault(__webpack_require__(338));
	
	var _lodash = _interopRequireDefault(__webpack_require__(323));
	
	var _classnames = _interopRequireDefault(__webpack_require__(11));
	
	var _innerSliderUtils = __webpack_require__(48);
	
	var _track = __webpack_require__(341);
	
	var _dots = __webpack_require__(336);
	
	var _arrows = __webpack_require__(334);
	
	var _resizeObserverPolyfill = _interopRequireDefault(__webpack_require__(343));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
	
	function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var InnerSlider =
	/*#__PURE__*/
	function (_React$Component) {
	  _inherits(InnerSlider, _React$Component);
	
	  function InnerSlider(props) {
	    var _this;
	
	    _classCallCheck(this, InnerSlider);
	
	    _this = _possibleConstructorReturn(this, _getPrototypeOf(InnerSlider).call(this, props));
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "listRefHandler", function (ref) {
	      return _this.list = ref;
	    });
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "trackRefHandler", function (ref) {
	      return _this.track = ref;
	    });
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "adaptHeight", function () {
	      if (_this.props.adaptiveHeight && _this.list) {
	        var elem = _this.list.querySelector("[data-index=\"".concat(_this.state.currentSlide, "\"]"));
	
	        _this.list.style.height = (0, _innerSliderUtils.getHeight)(elem) + "px";
	      }
	    });
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "componentWillMount", function () {
	      _this.ssrInit();
	
	      _this.props.onInit && _this.props.onInit();
	
	      if (_this.props.lazyLoad) {
	        var slidesToLoad = (0, _innerSliderUtils.getOnDemandLazySlides)(_objectSpread({}, _this.props, _this.state));
	
	        if (slidesToLoad.length > 0) {
	          _this.setState(function (prevState) {
	            return {
	              lazyLoadedList: prevState.lazyLoadedList.concat(slidesToLoad)
	            };
	          });
	
	          if (_this.props.onLazyLoad) {
	            _this.props.onLazyLoad(slidesToLoad);
	          }
	        }
	      }
	    });
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "componentDidMount", function () {
	      var spec = _objectSpread({
	        listRef: _this.list,
	        trackRef: _this.track
	      }, _this.props);
	
	      _this.updateState(spec, true, function () {
	        _this.adaptHeight();
	
	        _this.props.autoplay && _this.autoPlay("update");
	      });
	
	      if (_this.props.lazyLoad === "progressive") {
	        _this.lazyLoadTimer = setInterval(_this.progressiveLazyLoad, 1000);
	      }
	
	      _this.ro = new _resizeObserverPolyfill.default(function () {
	        if (_this.state.animating) {
	          _this.onWindowResized(false); // don't set trackStyle hence don't break animation
	
	
	          _this.callbackTimers.push(setTimeout(function () {
	            return _this.onWindowResized();
	          }, _this.props.speed));
	        } else {
	          _this.onWindowResized();
	        }
	      });
	
	      _this.ro.observe(_this.list);
	
	      Array.prototype.forEach.call(document.querySelectorAll(".slick-slide"), function (slide) {
	        slide.onfocus = _this.props.pauseOnFocus ? _this.onSlideFocus : null;
	        slide.onblur = _this.props.pauseOnFocus ? _this.onSlideBlur : null;
	      }); // To support server-side rendering
	
	      if (!window) {
	        return;
	      }
	
	      if (window.addEventListener) {
	        window.addEventListener("resize", _this.onWindowResized);
	      } else {
	        window.attachEvent("onresize", _this.onWindowResized);
	      }
	    });
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "componentWillUnmount", function () {
	      if (_this.animationEndCallback) {
	        clearTimeout(_this.animationEndCallback);
	      }
	
	      if (_this.lazyLoadTimer) {
	        clearInterval(_this.lazyLoadTimer);
	      }
	
	      if (_this.callbackTimers.length) {
	        _this.callbackTimers.forEach(function (timer) {
	          return clearTimeout(timer);
	        });
	
	        _this.callbackTimers = [];
	      }
	
	      if (window.addEventListener) {
	        window.removeEventListener("resize", _this.onWindowResized);
	      } else {
	        window.detachEvent("onresize", _this.onWindowResized);
	      }
	
	      if (_this.autoplayTimer) {
	        clearInterval(_this.autoplayTimer);
	      }
	    });
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "componentWillReceiveProps", function (nextProps) {
	      var spec = _objectSpread({
	        listRef: _this.list,
	        trackRef: _this.track
	      }, nextProps, _this.state);
	
	      var setTrackStyle = false;
	
	      var _arr = Object.keys(_this.props);
	
	      for (var _i = 0; _i < _arr.length; _i++) {
	        var key = _arr[_i];
	
	        if (!nextProps.hasOwnProperty(key)) {
	          setTrackStyle = true;
	          break;
	        }
	
	        if (_typeof(nextProps[key]) === "object" || typeof nextProps[key] === "function") {
	          continue;
	        }
	
	        if (nextProps[key] !== _this.props[key]) {
	          setTrackStyle = true;
	          break;
	        }
	      }
	
	      _this.updateState(spec, setTrackStyle, function () {
	        if (_this.state.currentSlide >= _react.default.Children.count(nextProps.children)) {
	          _this.changeSlide({
	            message: "index",
	            index: _react.default.Children.count(nextProps.children) - nextProps.slidesToShow,
	            currentSlide: _this.state.currentSlide
	          });
	        }
	
	        if (nextProps.autoplay) {
	          _this.autoPlay("update");
	        } else {
	          _this.pause("paused");
	        }
	      });
	    });
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "componentDidUpdate", function () {
	      _this.checkImagesLoad();
	
	      _this.props.onReInit && _this.props.onReInit();
	
	      if (_this.props.lazyLoad) {
	        var slidesToLoad = (0, _innerSliderUtils.getOnDemandLazySlides)(_objectSpread({}, _this.props, _this.state));
	
	        if (slidesToLoad.length > 0) {
	          _this.setState(function (prevState) {
	            return {
	              lazyLoadedList: prevState.lazyLoadedList.concat(slidesToLoad)
	            };
	          });
	
	          if (_this.props.onLazyLoad) {
	            _this.props.onLazyLoad(slidesToLoad);
	          }
	        }
	      } // if (this.props.onLazyLoad) {
	      //   this.props.onLazyLoad([leftMostSlide])
	      // }
	
	
	      _this.adaptHeight();
	    });
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onWindowResized", function (setTrackStyle) {
	      if (_this.debouncedResize) _this.debouncedResize.cancel();
	      _this.debouncedResize = (0, _lodash.default)(function () {
	        return _this.resizeWindow(setTrackStyle);
	      }, 50);
	
	      _this.debouncedResize();
	    });
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "resizeWindow", function () {
	      var setTrackStyle = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
	      if (!_reactDom.default.findDOMNode(_this.track)) return;
	
	      var spec = _objectSpread({
	        listRef: _this.list,
	        trackRef: _this.track
	      }, _this.props, _this.state);
	
	      _this.updateState(spec, setTrackStyle, function () {
	        if (_this.props.autoplay) _this.autoPlay("update");else _this.pause("paused");
	      }); // animating state should be cleared while resizing, otherwise autoplay stops working
	
	
	      _this.setState({
	        animating: false
	      });
	
	      clearTimeout(_this.animationEndCallback);
	      delete _this.animationEndCallback;
	    });
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "updateState", function (spec, setTrackStyle, callback) {
	      var updatedState = (0, _innerSliderUtils.initializedState)(spec);
	      spec = _objectSpread({}, spec, updatedState, {
	        slideIndex: updatedState.currentSlide
	      });
	      var targetLeft = (0, _innerSliderUtils.getTrackLeft)(spec);
	      spec = _objectSpread({}, spec, {
	        left: targetLeft
	      });
	      var trackStyle = (0, _innerSliderUtils.getTrackCSS)(spec);
	
	      if (setTrackStyle || _react.default.Children.count(_this.props.children) !== _react.default.Children.count(spec.children)) {
	        updatedState["trackStyle"] = trackStyle;
	      }
	
	      _this.setState(updatedState, callback);
	    });
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "ssrInit", function () {
	      if (_this.props.variableWidth) {
	        var _trackWidth = 0,
	            _trackLeft = 0;
	        var childrenWidths = [];
	        var preClones = (0, _innerSliderUtils.getPreClones)(_objectSpread({}, _this.props, _this.state, {
	          slideCount: _this.props.children.length
	        }));
	        var postClones = (0, _innerSliderUtils.getPostClones)(_objectSpread({}, _this.props, _this.state, {
	          slideCount: _this.props.children.length
	        }));
	
	        _this.props.children.forEach(function (child) {
	          childrenWidths.push(child.props.style.width);
	          _trackWidth += child.props.style.width;
	        });
	
	        for (var i = 0; i < preClones; i++) {
	          _trackLeft += childrenWidths[childrenWidths.length - 1 - i];
	          _trackWidth += childrenWidths[childrenWidths.length - 1 - i];
	        }
	
	        for (var _i2 = 0; _i2 < postClones; _i2++) {
	          _trackWidth += childrenWidths[_i2];
	        }
	
	        for (var _i3 = 0; _i3 < _this.state.currentSlide; _i3++) {
	          _trackLeft += childrenWidths[_i3];
	        }
	
	        var _trackStyle = {
	          width: _trackWidth + "px",
	          left: -_trackLeft + "px"
	        };
	
	        if (_this.props.centerMode) {
	          var currentWidth = "".concat(childrenWidths[_this.state.currentSlide], "px");
	          _trackStyle.left = "calc(".concat(_trackStyle.left, " + (100% - ").concat(currentWidth, ") / 2 ) ");
	        }
	
	        _this.setState({
	          trackStyle: _trackStyle
	        });
	
	        return;
	      }
	
	      var childrenCount = _react.default.Children.count(_this.props.children);
	
	      var spec = _objectSpread({}, _this.props, _this.state, {
	        slideCount: childrenCount
	      });
	
	      var slideCount = (0, _innerSliderUtils.getPreClones)(spec) + (0, _innerSliderUtils.getPostClones)(spec) + childrenCount;
	      var trackWidth = 100 / _this.props.slidesToShow * slideCount;
	      var slideWidth = 100 / slideCount;
	      var trackLeft = -slideWidth * ((0, _innerSliderUtils.getPreClones)(spec) + _this.state.currentSlide) * trackWidth / 100;
	
	      if (_this.props.centerMode) {
	        trackLeft += (100 - slideWidth * trackWidth / 100) / 2;
	      }
	
	      var trackStyle = {
	        width: trackWidth + "%",
	        left: trackLeft + "%"
	      };
	
	      _this.setState({
	        slideWidth: slideWidth + "%",
	        trackStyle: trackStyle
	      });
	    });
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "checkImagesLoad", function () {
	      var images = document.querySelectorAll(".slick-slide img");
	      var imagesCount = images.length,
	          loadedCount = 0;
	      Array.prototype.forEach.call(images, function (image) {
	        var handler = function handler() {
	          return ++loadedCount && loadedCount >= imagesCount && _this.onWindowResized();
	        };
	
	        if (!image.onclick) {
	          image.onclick = function () {
	            return image.parentNode.focus();
	          };
	        } else {
	          var prevClickHandler = image.onclick;
	
	          image.onclick = function () {
	            prevClickHandler();
	            image.parentNode.focus();
	          };
	        }
	
	        if (!image.onload) {
	          if (_this.props.lazyLoad) {
	            image.onload = function () {
	              _this.adaptHeight();
	
	              _this.callbackTimers.push(setTimeout(_this.onWindowResized, _this.props.speed));
	            };
	          } else {
	            image.onload = handler;
	
	            image.onerror = function () {
	              handler();
	              _this.props.onLazyLoadError && _this.props.onLazyLoadError();
	            };
	          }
	        }
	      });
	    });
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "progressiveLazyLoad", function () {
	      var slidesToLoad = [];
	
	      var spec = _objectSpread({}, _this.props, _this.state);
	
	      for (var index = _this.state.currentSlide; index < _this.state.slideCount + (0, _innerSliderUtils.getPostClones)(spec); index++) {
	        if (_this.state.lazyLoadedList.indexOf(index) < 0) {
	          slidesToLoad.push(index);
	          break;
	        }
	      }
	
	      for (var _index = _this.state.currentSlide - 1; _index >= -(0, _innerSliderUtils.getPreClones)(spec); _index--) {
	        if (_this.state.lazyLoadedList.indexOf(_index) < 0) {
	          slidesToLoad.push(_index);
	          break;
	        }
	      }
	
	      if (slidesToLoad.length > 0) {
	        _this.setState(function (state) {
	          return {
	            lazyLoadedList: state.lazyLoadedList.concat(slidesToLoad)
	          };
	        });
	
	        if (_this.props.onLazyLoad) {
	          _this.props.onLazyLoad(slidesToLoad);
	        }
	      } else {
	        if (_this.lazyLoadTimer) {
	          clearInterval(_this.lazyLoadTimer);
	          delete _this.lazyLoadTimer;
	        }
	      }
	    });
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "slideHandler", function (index) {
	      var dontAnimate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	      var _this$props = _this.props,
	          asNavFor = _this$props.asNavFor,
	          beforeChange = _this$props.beforeChange,
	          onLazyLoad = _this$props.onLazyLoad,
	          speed = _this$props.speed,
	          afterChange = _this$props.afterChange; // capture currentslide before state is updated
	
	      var currentSlide = _this.state.currentSlide;
	
	      var _slideHandler = (0, _innerSliderUtils.slideHandler)(_objectSpread({
	        index: index
	      }, _this.props, _this.state, {
	        trackRef: _this.track,
	        useCSS: _this.props.useCSS && !dontAnimate
	      })),
	          state = _slideHandler.state,
	          nextState = _slideHandler.nextState;
	
	      if (!state) return;
	      beforeChange && beforeChange(currentSlide, state.currentSlide);
	      var slidesToLoad = state.lazyLoadedList.filter(function (value) {
	        return _this.state.lazyLoadedList.indexOf(value) < 0;
	      });
	      onLazyLoad && slidesToLoad.length > 0 && onLazyLoad(slidesToLoad);
	
	      _this.setState(state, function () {
	        asNavFor && asNavFor.innerSlider.state.currentSlide !== _this.state.currentSlide && asNavFor.innerSlider.slideHandler(index);
	        if (!nextState) return;
	        _this.animationEndCallback = setTimeout(function () {
	          var animating = nextState.animating,
	              firstBatch = _objectWithoutProperties(nextState, ["animating"]);
	
	          _this.setState(firstBatch, function () {
	            _this.callbackTimers.push(setTimeout(function () {
	              return _this.setState({
	                animating: animating
	              });
	            }, 10));
	
	            afterChange && afterChange(state.currentSlide);
	            delete _this.animationEndCallback;
	          });
	        }, speed);
	      });
	    });
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "changeSlide", function (options) {
	      var dontAnimate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	      var spec = _objectSpread({}, _this.props, _this.state);
	
	      var targetSlide = (0, _innerSliderUtils.changeSlide)(spec, options);
	      if (targetSlide !== 0 && !targetSlide) return;
	
	      if (dontAnimate === true) {
	        _this.slideHandler(targetSlide, dontAnimate);
	      } else {
	        _this.slideHandler(targetSlide);
	      }
	    });
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "clickHandler", function (e) {
	      if (_this.clickable === false) {
	        e.stopPropagation();
	        e.preventDefault();
	      }
	
	      _this.clickable = true;
	    });
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "keyHandler", function (e) {
	      var dir = (0, _innerSliderUtils.keyHandler)(e, _this.props.accessibility, _this.props.rtl);
	      dir !== "" && _this.changeSlide({
	        message: dir
	      });
	    });
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "selectHandler", function (options) {
	      _this.changeSlide(options);
	    });
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "disableBodyScroll", function () {
	      var preventDefault = function preventDefault(e) {
	        e = e || window.event;
	        if (e.preventDefault) e.preventDefault();
	        e.returnValue = false;
	      };
	
	      window.ontouchmove = preventDefault;
	    });
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "enableBodyScroll", function () {
	      window.ontouchmove = null;
	    });
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "swipeStart", function (e) {
	      if (_this.props.verticalSwiping) {
	        _this.disableBodyScroll();
	      }
	
	      var state = (0, _innerSliderUtils.swipeStart)(e, _this.props.swipe, _this.props.draggable);
	      state !== "" && _this.setState(state);
	    });
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "swipeMove", function (e) {
	      var state = (0, _innerSliderUtils.swipeMove)(e, _objectSpread({}, _this.props, _this.state, {
	        trackRef: _this.track,
	        listRef: _this.list,
	        slideIndex: _this.state.currentSlide
	      }));
	      if (!state) return;
	
	      if (state["swiping"]) {
	        _this.clickable = false;
	      }
	
	      _this.setState(state);
	    });
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "swipeEnd", function (e) {
	      var state = (0, _innerSliderUtils.swipeEnd)(e, _objectSpread({}, _this.props, _this.state, {
	        trackRef: _this.track,
	        listRef: _this.list,
	        slideIndex: _this.state.currentSlide
	      }));
	      if (!state) return;
	      var triggerSlideHandler = state["triggerSlideHandler"];
	      delete state["triggerSlideHandler"];
	
	      _this.setState(state);
	
	      if (triggerSlideHandler === undefined) return;
	
	      _this.slideHandler(triggerSlideHandler);
	
	      if (_this.props.verticalSwiping) {
	        _this.enableBodyScroll();
	      }
	    });
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "slickPrev", function () {
	      // this and fellow methods are wrapped in setTimeout
	      // to make sure initialize setState has happened before
	      // any of such methods are called
	      _this.callbackTimers.push(setTimeout(function () {
	        return _this.changeSlide({
	          message: "previous"
	        });
	      }, 0));
	    });
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "slickNext", function () {
	      _this.callbackTimers.push(setTimeout(function () {
	        return _this.changeSlide({
	          message: "next"
	        });
	      }, 0));
	    });
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "slickGoTo", function (slide) {
	      var dontAnimate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	      slide = Number(slide);
	      if (isNaN(slide)) return "";
	
	      _this.callbackTimers.push(setTimeout(function () {
	        return _this.changeSlide({
	          message: "index",
	          index: slide,
	          currentSlide: _this.state.currentSlide
	        }, dontAnimate);
	      }, 0));
	    });
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "play", function () {
	      var nextIndex;
	
	      if (_this.props.rtl) {
	        nextIndex = _this.state.currentSlide - _this.props.slidesToScroll;
	      } else {
	        if ((0, _innerSliderUtils.canGoNext)(_objectSpread({}, _this.props, _this.state))) {
	          nextIndex = _this.state.currentSlide + _this.props.slidesToScroll;
	        } else {
	          return false;
	        }
	      }
	
	      _this.slideHandler(nextIndex);
	    });
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "autoPlay", function (playType) {
	      if (_this.autoplayTimer) {
	        clearInterval(_this.autoplayTimer);
	      }
	
	      var autoplaying = _this.state.autoplaying;
	
	      if (playType === "update") {
	        if (autoplaying === "hovered" || autoplaying === "focused" || autoplaying === "paused") {
	          return;
	        }
	      } else if (playType === "leave") {
	        if (autoplaying === "paused" || autoplaying === "focused") {
	          return;
	        }
	      } else if (playType === "blur") {
	        if (autoplaying === "paused" || autoplaying === "hovered") {
	          return;
	        }
	      }
	
	      _this.autoplayTimer = setInterval(_this.play, _this.props.autoplaySpeed + 50);
	
	      _this.setState({
	        autoplaying: "playing"
	      });
	    });
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "pause", function (pauseType) {
	      if (_this.autoplayTimer) {
	        clearInterval(_this.autoplayTimer);
	        _this.autoplayTimer = null;
	      }
	
	      var autoplaying = _this.state.autoplaying;
	
	      if (pauseType === "paused") {
	        _this.setState({
	          autoplaying: "paused"
	        });
	      } else if (pauseType === "focused") {
	        if (autoplaying === "hovered" || autoplaying === "playing") {
	          _this.setState({
	            autoplaying: "focused"
	          });
	        }
	      } else {
	        // pauseType  is 'hovered'
	        if (autoplaying === "playing") {
	          _this.setState({
	            autoplaying: "hovered"
	          });
	        }
	      }
	    });
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onDotsOver", function () {
	      return _this.props.autoplay && _this.pause("hovered");
	    });
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onDotsLeave", function () {
	      return _this.props.autoplay && _this.state.autoplaying === "hovered" && _this.autoPlay("leave");
	    });
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onTrackOver", function () {
	      return _this.props.autoplay && _this.pause("hovered");
	    });
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onTrackLeave", function () {
	      return _this.props.autoplay && _this.state.autoplaying === "hovered" && _this.autoPlay("leave");
	    });
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onSlideFocus", function () {
	      return _this.props.autoplay && _this.pause("focused");
	    });
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onSlideBlur", function () {
	      return _this.props.autoplay && _this.state.autoplaying === "focused" && _this.autoPlay("blur");
	    });
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "render", function () {
	      var className = (0, _classnames.default)("slick-slider", _this.props.className, {
	        "slick-vertical": _this.props.vertical,
	        "slick-initialized": true
	      });
	
	      var spec = _objectSpread({}, _this.props, _this.state);
	
	      var trackProps = (0, _innerSliderUtils.extractObject)(spec, ["fade", "cssEase", "speed", "infinite", "centerMode", "focusOnSelect", "currentSlide", "lazyLoad", "lazyLoadedList", "rtl", "slideWidth", "slideHeight", "listHeight", "vertical", "slidesToShow", "slidesToScroll", "slideCount", "trackStyle", "variableWidth", "unslick", "centerPadding"]);
	      var pauseOnHover = _this.props.pauseOnHover;
	      trackProps = _objectSpread({}, trackProps, {
	        onMouseEnter: pauseOnHover ? _this.onTrackOver : null,
	        onMouseLeave: pauseOnHover ? _this.onTrackLeave : null,
	        onMouseOver: pauseOnHover ? _this.onTrackOver : null,
	        focusOnSelect: _this.props.focusOnSelect ? _this.selectHandler : null
	      });
	      var dots;
	
	      if (_this.props.dots === true && _this.state.slideCount >= _this.props.slidesToShow) {
	        var dotProps = (0, _innerSliderUtils.extractObject)(spec, ["dotsClass", "slideCount", "slidesToShow", "currentSlide", "slidesToScroll", "clickHandler", "children", "customPaging", "infinite", "appendDots"]);
	        var pauseOnDotsHover = _this.props.pauseOnDotsHover;
	        dotProps = _objectSpread({}, dotProps, {
	          clickHandler: _this.changeSlide,
	          onMouseEnter: pauseOnDotsHover ? _this.onDotsLeave : null,
	          onMouseOver: pauseOnDotsHover ? _this.onDotsOver : null,
	          onMouseLeave: pauseOnDotsHover ? _this.onDotsLeave : null
	        });
	        dots = _react.default.createElement(_dots.Dots, dotProps);
	      }
	
	      var prevArrow, nextArrow;
	      var arrowProps = (0, _innerSliderUtils.extractObject)(spec, ["infinite", "centerMode", "currentSlide", "slideCount", "slidesToShow", "prevArrow", "nextArrow"]);
	      arrowProps.clickHandler = _this.changeSlide;
	
	      if (_this.props.arrows) {
	        prevArrow = _react.default.createElement(_arrows.PrevArrow, arrowProps);
	        nextArrow = _react.default.createElement(_arrows.NextArrow, arrowProps);
	      }
	
	      var verticalHeightStyle = null;
	
	      if (_this.props.vertical) {
	        verticalHeightStyle = {
	          height: _this.state.listHeight
	        };
	      }
	
	      var centerPaddingStyle = null;
	
	      if (_this.props.vertical === false) {
	        if (_this.props.centerMode === true) {
	          centerPaddingStyle = {
	            padding: "0px " + _this.props.centerPadding
	          };
	        }
	      } else {
	        if (_this.props.centerMode === true) {
	          centerPaddingStyle = {
	            padding: _this.props.centerPadding + " 0px"
	          };
	        }
	      }
	
	      var listStyle = _objectSpread({}, verticalHeightStyle, centerPaddingStyle);
	
	      var touchMove = _this.props.touchMove;
	      var listProps = {
	        className: "slick-list",
	        style: listStyle,
	        onClick: _this.clickHandler,
	        onMouseDown: touchMove ? _this.swipeStart : null,
	        onMouseMove: _this.state.dragging && touchMove ? _this.swipeMove : null,
	        onMouseUp: touchMove ? _this.swipeEnd : null,
	        onMouseLeave: _this.state.dragging && touchMove ? _this.swipeEnd : null,
	        onTouchStart: touchMove ? _this.swipeStart : null,
	        onTouchMove: _this.state.dragging && touchMove ? _this.swipeMove : null,
	        onTouchEnd: touchMove ? _this.swipeEnd : null,
	        onTouchCancel: _this.state.dragging && touchMove ? _this.swipeEnd : null,
	        onKeyDown: _this.props.accessibility ? _this.keyHandler : null
	      };
	      var innerSliderProps = {
	        className: className,
	        dir: "ltr"
	      };
	
	      if (_this.props.unslick) {
	        listProps = {
	          className: "slick-list"
	        };
	        innerSliderProps = {
	          className: className
	        };
	      }
	
	      return _react.default.createElement("div", innerSliderProps, !_this.props.unslick ? prevArrow : "", _react.default.createElement("div", _extends({
	        ref: _this.listRefHandler
	      }, listProps), _react.default.createElement(_track.Track, _extends({
	        ref: _this.trackRefHandler
	      }, trackProps), _this.props.children)), !_this.props.unslick ? nextArrow : "", !_this.props.unslick ? dots : "");
	    });
	
	    _this.list = null;
	    _this.track = null;
	    _this.state = _objectSpread({}, _initialState.default, {
	      currentSlide: _this.props.initialSlide,
	      slideCount: _react.default.Children.count(_this.props.children)
	    });
	    _this.callbackTimers = [];
	    _this.clickable = true;
	    _this.debouncedResize = null;
	    return _this;
	  }
	
	  return InnerSlider;
	}(_react.default.Component);
	
	exports.InnerSlider = InnerSlider;

/***/ }),

/***/ 340:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _innerSlider = __webpack_require__(339);
	
	var _json2mq = _interopRequireDefault(__webpack_require__(322));
	
	var _defaultProps = _interopRequireDefault(__webpack_require__(335));
	
	var _innerSliderUtils = __webpack_require__(48);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var enquire = (0, _innerSliderUtils.canUseDOM)() && __webpack_require__(245);
	
	var Slider =
	/*#__PURE__*/
	function (_React$Component) {
	  _inherits(Slider, _React$Component);
	
	  function Slider(props) {
	    var _this;
	
	    _classCallCheck(this, Slider);
	
	    _this = _possibleConstructorReturn(this, _getPrototypeOf(Slider).call(this, props));
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "innerSliderRefHandler", function (ref) {
	      return _this.innerSlider = ref;
	    });
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "slickPrev", function () {
	      return _this.innerSlider.slickPrev();
	    });
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "slickNext", function () {
	      return _this.innerSlider.slickNext();
	    });
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "slickGoTo", function (slide) {
	      var dontAnimate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	      return _this.innerSlider.slickGoTo(slide, dontAnimate);
	    });
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "slickPause", function () {
	      return _this.innerSlider.pause("paused");
	    });
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "slickPlay", function () {
	      return _this.innerSlider.autoPlay("play");
	    });
	
	    _this.state = {
	      breakpoint: null
	    };
	    _this._responsiveMediaHandlers = [];
	    return _this;
	  }
	
	  _createClass(Slider, [{
	    key: "media",
	    value: function media(query, handler) {
	      // javascript handler for  css media query
	      enquire.register(query, handler);
	
	      this._responsiveMediaHandlers.push({
	        query: query,
	        handler: handler
	      });
	    } // handles responsive breakpoints
	
	  }, {
	    key: "componentWillMount",
	    value: function componentWillMount() {
	      var _this2 = this;
	
	      // performance monitoring
	      //if (process.env.NODE_ENV !== 'production') {
	      //const { whyDidYouUpdate } = require('why-did-you-update')
	      //whyDidYouUpdate(React)
	      //}
	      if (this.props.responsive) {
	        var breakpoints = this.props.responsive.map(function (breakpt) {
	          return breakpt.breakpoint;
	        }); // sort them in increasing order of their numerical value
	
	        breakpoints.sort(function (x, y) {
	          return x - y;
	        });
	        breakpoints.forEach(function (breakpoint, index) {
	          // media query for each breakpoint
	          var bQuery;
	
	          if (index === 0) {
	            bQuery = (0, _json2mq.default)({
	              minWidth: 0,
	              maxWidth: breakpoint
	            });
	          } else {
	            bQuery = (0, _json2mq.default)({
	              minWidth: breakpoints[index - 1] + 1,
	              maxWidth: breakpoint
	            });
	          } // when not using server side rendering
	
	
	          (0, _innerSliderUtils.canUseDOM)() && _this2.media(bQuery, function () {
	            _this2.setState({
	              breakpoint: breakpoint
	            });
	          });
	        }); // Register media query for full screen. Need to support resize from small to large
	        // convert javascript object to media query string
	
	        var query = (0, _json2mq.default)({
	          minWidth: breakpoints.slice(-1)[0]
	        });
	        (0, _innerSliderUtils.canUseDOM)() && this.media(query, function () {
	          _this2.setState({
	            breakpoint: null
	          });
	        });
	      }
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      this._responsiveMediaHandlers.forEach(function (obj) {
	        enquire.unregister(obj.query, obj.handler);
	      });
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this3 = this;
	
	      var settings;
	      var newProps;
	
	      if (this.state.breakpoint) {
	        newProps = this.props.responsive.filter(function (resp) {
	          return resp.breakpoint === _this3.state.breakpoint;
	        });
	        settings = newProps[0].settings === "unslick" ? "unslick" : _objectSpread({}, _defaultProps.default, this.props, newProps[0].settings);
	      } else {
	        settings = _objectSpread({}, _defaultProps.default, this.props);
	      } // force scrolling by one if centerMode is on
	
	
	      if (settings.centerMode) {
	        if (settings.slidesToScroll > 1 && ("production") !== "production") {
	          console.warn("slidesToScroll should be equal to 1 in centerMode, you are using ".concat(settings.slidesToScroll));
	        }
	
	        settings.slidesToScroll = 1;
	      } // force showing one slide and scrolling by one if the fade mode is on
	
	
	      if (settings.fade) {
	        if (settings.slidesToShow > 1 && ("production") !== "production") {
	          console.warn("slidesToShow should be equal to 1 when fade is true, you're using ".concat(settings.slidesToShow));
	        }
	
	        if (settings.slidesToScroll > 1 && ("production") !== "production") {
	          console.warn("slidesToScroll should be equal to 1 when fade is true, you're using ".concat(settings.slidesToScroll));
	        }
	
	        settings.slidesToShow = 1;
	        settings.slidesToScroll = 1;
	      } // makes sure that children is an array, even when there is only 1 child
	
	
	      var children = _react.default.Children.toArray(this.props.children); // Children may contain false or null, so we should filter them
	      // children may also contain string filled with spaces (in certain cases where we use jsx strings)
	
	
	      children = children.filter(function (child) {
	        if (typeof child === "string") {
	          return !!child.trim();
	        }
	
	        return !!child;
	      }); // rows and slidesPerRow logic is handled here
	
	      if (settings.variableWidth && (settings.rows > 1 || settings.slidesPerRow > 1)) {
	        console.warn("variableWidth is not supported in case of rows > 1 or slidesPerRow > 1");
	        settings.variableWidth = false;
	      }
	
	      var newChildren = [];
	      var currentWidth = null;
	
	      for (var i = 0; i < children.length; i += settings.rows * settings.slidesPerRow) {
	        var newSlide = [];
	
	        for (var j = i; j < i + settings.rows * settings.slidesPerRow; j += settings.slidesPerRow) {
	          var row = [];
	
	          for (var k = j; k < j + settings.slidesPerRow; k += 1) {
	            if (settings.variableWidth && children[k].props.style) {
	              currentWidth = children[k].props.style.width;
	            }
	
	            if (k >= children.length) break;
	            row.push(_react.default.cloneElement(children[k], {
	              key: 100 * i + 10 * j + k,
	              tabIndex: -1,
	              style: {
	                width: "".concat(100 / settings.slidesPerRow, "%"),
	                display: "inline-block"
	              }
	            }));
	          }
	
	          newSlide.push(_react.default.createElement("div", {
	            key: 10 * i + j
	          }, row));
	        }
	
	        if (settings.variableWidth) {
	          newChildren.push(_react.default.createElement("div", {
	            key: i,
	            style: {
	              width: currentWidth
	            }
	          }, newSlide));
	        } else {
	          newChildren.push(_react.default.createElement("div", {
	            key: i
	          }, newSlide));
	        }
	      }
	
	      if (settings === "unslick") {
	        var className = "regular slider " + (this.props.className || "");
	        return _react.default.createElement("div", {
	          className: className
	        }, newChildren);
	      } else if (newChildren.length <= settings.slidesToShow) {
	        settings.unslick = true;
	      }
	
	      return _react.default.createElement(_innerSlider.InnerSlider, _extends({
	        ref: this.innerSliderRefHandler
	      }, settings), newChildren);
	    }
	  }]);
	
	  return Slider;
	}(_react.default.Component);
	
	exports.default = Slider;

/***/ }),

/***/ 341:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Track = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _classnames = _interopRequireDefault(__webpack_require__(11));
	
	var _innerSliderUtils = __webpack_require__(48);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	// given specifications/props for a slide, fetch all the classes that need to be applied to the slide
	var getSlideClasses = function getSlideClasses(spec) {
	  var slickActive, slickCenter, slickCloned;
	  var centerOffset, index;
	
	  if (spec.rtl) {
	    index = spec.slideCount - 1 - spec.index;
	  } else {
	    index = spec.index;
	  }
	
	  slickCloned = index < 0 || index >= spec.slideCount;
	
	  if (spec.centerMode) {
	    centerOffset = Math.floor(spec.slidesToShow / 2);
	    slickCenter = (index - spec.currentSlide) % spec.slideCount === 0;
	
	    if (index > spec.currentSlide - centerOffset - 1 && index <= spec.currentSlide + centerOffset) {
	      slickActive = true;
	    }
	  } else {
	    slickActive = spec.currentSlide <= index && index < spec.currentSlide + spec.slidesToShow;
	  }
	
	  var slickCurrent = index === spec.currentSlide;
	  return {
	    "slick-slide": true,
	    "slick-active": slickActive,
	    "slick-center": slickCenter,
	    "slick-cloned": slickCloned,
	    "slick-current": slickCurrent // dubious in case of RTL
	
	  };
	};
	
	var getSlideStyle = function getSlideStyle(spec) {
	  var style = {};
	
	  if (spec.variableWidth === undefined || spec.variableWidth === false) {
	    style.width = spec.slideWidth;
	  }
	
	  if (spec.fade) {
	    style.position = "relative";
	
	    if (spec.vertical) {
	      style.top = -spec.index * parseInt(spec.slideHeight);
	    } else {
	      style.left = -spec.index * parseInt(spec.slideWidth);
	    }
	
	    style.opacity = spec.currentSlide === spec.index ? 1 : 0;
	    style.transition = "opacity " + spec.speed + "ms " + spec.cssEase + ", " + "visibility " + spec.speed + "ms " + spec.cssEase;
	    style.WebkitTransition = "opacity " + spec.speed + "ms " + spec.cssEase + ", " + "visibility " + spec.speed + "ms " + spec.cssEase;
	  }
	
	  return style;
	};
	
	var getKey = function getKey(child, fallbackKey) {
	  return child.key || fallbackKey;
	};
	
	var renderSlides = function renderSlides(spec) {
	  var key;
	  var slides = [];
	  var preCloneSlides = [];
	  var postCloneSlides = [];
	
	  var childrenCount = _react.default.Children.count(spec.children);
	
	  var startIndex = (0, _innerSliderUtils.lazyStartIndex)(spec);
	  var endIndex = (0, _innerSliderUtils.lazyEndIndex)(spec);
	
	  _react.default.Children.forEach(spec.children, function (elem, index) {
	    var child;
	    var childOnClickOptions = {
	      message: "children",
	      index: index,
	      slidesToScroll: spec.slidesToScroll,
	      currentSlide: spec.currentSlide
	    }; // in case of lazyLoad, whether or not we want to fetch the slide
	
	    if (!spec.lazyLoad || spec.lazyLoad && spec.lazyLoadedList.indexOf(index) >= 0) {
	      child = elem;
	    } else {
	      child = _react.default.createElement("div", null);
	    }
	
	    var childStyle = getSlideStyle(_objectSpread({}, spec, {
	      index: index
	    }));
	    var slideClass = child.props.className || "";
	    var slideClasses = getSlideClasses(_objectSpread({}, spec, {
	      index: index
	    })); // push a cloned element of the desired slide
	
	    slides.push(_react.default.cloneElement(child, {
	      key: "original" + getKey(child, index),
	      "data-index": index,
	      className: (0, _classnames.default)(slideClasses, slideClass),
	      tabIndex: "-1",
	      "aria-hidden": !slideClasses["slick-active"],
	      style: _objectSpread({
	        outline: "none"
	      }, child.props.style || {}, childStyle),
	      onClick: function onClick(e) {
	        child.props && child.props.onClick && child.props.onClick(e);
	
	        if (spec.focusOnSelect) {
	          spec.focusOnSelect(childOnClickOptions);
	        }
	      }
	    })); // if slide needs to be precloned or postcloned
	
	    if (spec.infinite && spec.fade === false) {
	      var preCloneNo = childrenCount - index;
	
	      if (preCloneNo <= (0, _innerSliderUtils.getPreClones)(spec) && childrenCount !== spec.slidesToShow) {
	        key = -preCloneNo;
	
	        if (key >= startIndex) {
	          child = elem;
	        }
	
	        slideClasses = getSlideClasses(_objectSpread({}, spec, {
	          index: key
	        }));
	        preCloneSlides.push(_react.default.cloneElement(child, {
	          key: "precloned" + getKey(child, key),
	          "data-index": key,
	          tabIndex: "-1",
	          className: (0, _classnames.default)(slideClasses, slideClass),
	          "aria-hidden": !slideClasses["slick-active"],
	          style: _objectSpread({}, child.props.style || {}, childStyle),
	          onClick: function onClick(e) {
	            child.props && child.props.onClick && child.props.onClick(e);
	
	            if (spec.focusOnSelect) {
	              spec.focusOnSelect(childOnClickOptions);
	            }
	          }
	        }));
	      }
	
	      if (childrenCount !== spec.slidesToShow) {
	        key = childrenCount + index;
	
	        if (key < endIndex) {
	          child = elem;
	        }
	
	        slideClasses = getSlideClasses(_objectSpread({}, spec, {
	          index: key
	        }));
	        postCloneSlides.push(_react.default.cloneElement(child, {
	          key: "postcloned" + getKey(child, key),
	          "data-index": key,
	          tabIndex: "-1",
	          className: (0, _classnames.default)(slideClasses, slideClass),
	          "aria-hidden": !slideClasses["slick-active"],
	          style: _objectSpread({}, child.props.style || {}, childStyle),
	          onClick: function onClick(e) {
	            child.props && child.props.onClick && child.props.onClick(e);
	
	            if (spec.focusOnSelect) {
	              spec.focusOnSelect(childOnClickOptions);
	            }
	          }
	        }));
	      }
	    }
	  });
	
	  if (spec.rtl) {
	    return preCloneSlides.concat(slides, postCloneSlides).reverse();
	  } else {
	    return preCloneSlides.concat(slides, postCloneSlides);
	  }
	};
	
	var Track =
	/*#__PURE__*/
	function (_React$PureComponent) {
	  _inherits(Track, _React$PureComponent);
	
	  function Track() {
	    _classCallCheck(this, Track);
	
	    return _possibleConstructorReturn(this, _getPrototypeOf(Track).apply(this, arguments));
	  }
	
	  _createClass(Track, [{
	    key: "render",
	    value: function render() {
	      var slides = renderSlides(this.props);
	      var _this$props = this.props,
	          onMouseEnter = _this$props.onMouseEnter,
	          onMouseOver = _this$props.onMouseOver,
	          onMouseLeave = _this$props.onMouseLeave;
	      var mouseEvents = {
	        onMouseEnter: onMouseEnter,
	        onMouseOver: onMouseOver,
	        onMouseLeave: onMouseLeave
	      };
	      return _react.default.createElement("div", _extends({
	        className: "slick-track",
	        style: this.props.trackStyle
	      }, mouseEvents), slides);
	    }
	  }]);
	
	  return Track;
	}(_react.default.PureComponent);
	
	exports.Track = Track;

/***/ }),

/***/ 48:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.canUseDOM = exports.slidesOnLeft = exports.slidesOnRight = exports.siblingDirection = exports.getTotalSlides = exports.getPostClones = exports.getPreClones = exports.getTrackLeft = exports.getTrackAnimateCSS = exports.getTrackCSS = exports.checkSpecKeys = exports.getSlideCount = exports.checkNavigable = exports.getNavigableIndexes = exports.swipeEnd = exports.swipeMove = exports.swipeStart = exports.keyHandler = exports.changeSlide = exports.slideHandler = exports.initializedState = exports.extractObject = exports.canGoNext = exports.getSwipeDirection = exports.getHeight = exports.getWidth = exports.lazySlidesOnRight = exports.lazySlidesOnLeft = exports.lazyEndIndex = exports.lazyStartIndex = exports.getRequiredLazySlides = exports.getOnDemandLazySlides = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _reactDom = _interopRequireDefault(__webpack_require__(47));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var getOnDemandLazySlides = function getOnDemandLazySlides(spec) {
	  var onDemandSlides = [];
	  var startIndex = lazyStartIndex(spec);
	  var endIndex = lazyEndIndex(spec);
	
	  for (var slideIndex = startIndex; slideIndex < endIndex; slideIndex++) {
	    if (spec.lazyLoadedList.indexOf(slideIndex) < 0) {
	      onDemandSlides.push(slideIndex);
	    }
	  }
	
	  return onDemandSlides;
	}; // return list of slides that need to be present
	
	
	exports.getOnDemandLazySlides = getOnDemandLazySlides;
	
	var getRequiredLazySlides = function getRequiredLazySlides(spec) {
	  var requiredSlides = [];
	  var startIndex = lazyStartIndex(spec);
	  var endIndex = lazyEndIndex(spec);
	
	  for (var slideIndex = startIndex; slideIndex < endIndex; slideIndex++) {
	    requiredSlides.push(slideIndex);
	  }
	
	  return requiredSlides;
	}; // startIndex that needs to be present
	
	
	exports.getRequiredLazySlides = getRequiredLazySlides;
	
	var lazyStartIndex = function lazyStartIndex(spec) {
	  return spec.currentSlide - lazySlidesOnLeft(spec);
	};
	
	exports.lazyStartIndex = lazyStartIndex;
	
	var lazyEndIndex = function lazyEndIndex(spec) {
	  return spec.currentSlide + lazySlidesOnRight(spec);
	};
	
	exports.lazyEndIndex = lazyEndIndex;
	
	var lazySlidesOnLeft = function lazySlidesOnLeft(spec) {
	  return spec.centerMode ? Math.floor(spec.slidesToShow / 2) + (parseInt(spec.centerPadding) > 0 ? 1 : 0) : 0;
	};
	
	exports.lazySlidesOnLeft = lazySlidesOnLeft;
	
	var lazySlidesOnRight = function lazySlidesOnRight(spec) {
	  return spec.centerMode ? Math.floor((spec.slidesToShow - 1) / 2) + 1 + (parseInt(spec.centerPadding) > 0 ? 1 : 0) : spec.slidesToShow;
	}; // get width of an element
	
	
	exports.lazySlidesOnRight = lazySlidesOnRight;
	
	var getWidth = function getWidth(elem) {
	  return elem && elem.offsetWidth || 0;
	};
	
	exports.getWidth = getWidth;
	
	var getHeight = function getHeight(elem) {
	  return elem && elem.offsetHeight || 0;
	};
	
	exports.getHeight = getHeight;
	
	var getSwipeDirection = function getSwipeDirection(touchObject) {
	  var verticalSwiping = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	  var xDist, yDist, r, swipeAngle;
	  xDist = touchObject.startX - touchObject.curX;
	  yDist = touchObject.startY - touchObject.curY;
	  r = Math.atan2(yDist, xDist);
	  swipeAngle = Math.round(r * 180 / Math.PI);
	
	  if (swipeAngle < 0) {
	    swipeAngle = 360 - Math.abs(swipeAngle);
	  }
	
	  if (swipeAngle <= 45 && swipeAngle >= 0 || swipeAngle <= 360 && swipeAngle >= 315) {
	    return "left";
	  }
	
	  if (swipeAngle >= 135 && swipeAngle <= 225) {
	    return "right";
	  }
	
	  if (verticalSwiping === true) {
	    if (swipeAngle >= 35 && swipeAngle <= 135) {
	      return "up";
	    } else {
	      return "down";
	    }
	  }
	
	  return "vertical";
	}; // whether or not we can go next
	
	
	exports.getSwipeDirection = getSwipeDirection;
	
	var canGoNext = function canGoNext(spec) {
	  var canGo = true;
	
	  if (!spec.infinite) {
	    if (spec.centerMode && spec.currentSlide >= spec.slideCount - 1) {
	      canGo = false;
	    } else if (spec.slideCount <= spec.slidesToShow || spec.currentSlide >= spec.slideCount - spec.slidesToShow) {
	      canGo = false;
	    }
	  }
	
	  return canGo;
	}; // given an object and a list of keys, return new object with given keys
	
	
	exports.canGoNext = canGoNext;
	
	var extractObject = function extractObject(spec, keys) {
	  var newObject = {};
	  keys.forEach(function (key) {
	    return newObject[key] = spec[key];
	  });
	  return newObject;
	}; // get initialized state
	
	
	exports.extractObject = extractObject;
	
	var initializedState = function initializedState(spec) {
	  // spec also contains listRef, trackRef
	  var slideCount = _react.default.Children.count(spec.children);
	
	  var listWidth = Math.ceil(getWidth(_reactDom.default.findDOMNode(spec.listRef)));
	  var trackWidth = Math.ceil(getWidth(_reactDom.default.findDOMNode(spec.trackRef)));
	  var slideWidth;
	
	  if (!spec.vertical) {
	    var centerPaddingAdj = spec.centerMode && parseInt(spec.centerPadding) * 2;
	
	    if (typeof spec.centerPadding === "string" && spec.centerPadding.slice(-1) === "%") {
	      centerPaddingAdj *= listWidth / 100;
	    }
	
	    slideWidth = Math.ceil((listWidth - centerPaddingAdj) / spec.slidesToShow);
	  } else {
	    slideWidth = listWidth;
	  }
	
	  var slideHeight = _reactDom.default.findDOMNode(spec.listRef) && getHeight(_reactDom.default.findDOMNode(spec.listRef).querySelector('[data-index="0"]'));
	  var listHeight = slideHeight * spec.slidesToShow;
	  var currentSlide = spec.currentSlide === undefined ? spec.initialSlide : spec.currentSlide;
	
	  if (spec.rtl && spec.currentSlide === undefined) {
	    currentSlide = slideCount - 1 - spec.initialSlide;
	  }
	
	  var lazyLoadedList = spec.lazyLoadedList || [];
	  var slidesToLoad = getOnDemandLazySlides({
	    currentSlide: currentSlide,
	    lazyLoadedList: lazyLoadedList
	  }, spec);
	  lazyLoadedList.concat(slidesToLoad);
	  var state = {
	    slideCount: slideCount,
	    slideWidth: slideWidth,
	    listWidth: listWidth,
	    trackWidth: trackWidth,
	    currentSlide: currentSlide,
	    slideHeight: slideHeight,
	    listHeight: listHeight,
	    lazyLoadedList: lazyLoadedList
	  };
	
	  if (spec.autoplaying === null && spec.autoplay) {
	    state["autoplaying"] = "playing";
	  }
	
	  return state;
	};
	
	exports.initializedState = initializedState;
	
	var slideHandler = function slideHandler(spec) {
	  var waitForAnimate = spec.waitForAnimate,
	      animating = spec.animating,
	      fade = spec.fade,
	      infinite = spec.infinite,
	      index = spec.index,
	      slideCount = spec.slideCount,
	      lazyLoadedList = spec.lazyLoadedList,
	      lazyLoad = spec.lazyLoad,
	      currentSlide = spec.currentSlide,
	      centerMode = spec.centerMode,
	      slidesToScroll = spec.slidesToScroll,
	      slidesToShow = spec.slidesToShow,
	      useCSS = spec.useCSS;
	  if (waitForAnimate && animating) return {};
	  var animationSlide = index,
	      finalSlide,
	      animationLeft,
	      finalLeft;
	  var state = {},
	      nextState = {};
	
	  if (fade) {
	    if (!infinite && (index < 0 || index >= slideCount)) return {};
	
	    if (index < 0) {
	      animationSlide = index + slideCount;
	    } else if (index >= slideCount) {
	      animationSlide = index - slideCount;
	    }
	
	    if (lazyLoad && lazyLoadedList.indexOf(animationSlide) < 0) {
	      lazyLoadedList.push(animationSlide);
	    }
	
	    state = {
	      animating: true,
	      currentSlide: animationSlide,
	      lazyLoadedList: lazyLoadedList
	    };
	    nextState = {
	      animating: false
	    };
	  } else {
	    finalSlide = animationSlide;
	
	    if (animationSlide < 0) {
	      finalSlide = animationSlide + slideCount;
	      if (!infinite) finalSlide = 0;else if (slideCount % slidesToScroll !== 0) finalSlide = slideCount - slideCount % slidesToScroll;
	    } else if (!canGoNext(spec) && animationSlide > currentSlide) {
	      animationSlide = finalSlide = currentSlide;
	    } else if (centerMode && animationSlide >= slideCount) {
	      animationSlide = infinite ? slideCount : slideCount - 1;
	      finalSlide = infinite ? 0 : slideCount - 1;
	    } else if (animationSlide >= slideCount) {
	      finalSlide = animationSlide - slideCount;
	      if (!infinite) finalSlide = slideCount - slidesToShow;else if (slideCount % slidesToScroll !== 0) finalSlide = 0;
	    }
	
	    animationLeft = getTrackLeft(_objectSpread({}, spec, {
	      slideIndex: animationSlide
	    }));
	    finalLeft = getTrackLeft(_objectSpread({}, spec, {
	      slideIndex: finalSlide
	    }));
	
	    if (!infinite) {
	      if (animationLeft === finalLeft) animationSlide = finalSlide;
	      animationLeft = finalLeft;
	    }
	
	    lazyLoad && lazyLoadedList.concat(getOnDemandLazySlides(_objectSpread({}, spec, {
	      currentSlide: animationSlide
	    })));
	
	    if (!useCSS) {
	      state = {
	        currentSlide: finalSlide,
	        trackStyle: getTrackCSS(_objectSpread({}, spec, {
	          left: finalLeft
	        })),
	        lazyLoadedList: lazyLoadedList
	      };
	    } else {
	      state = {
	        animating: true,
	        currentSlide: finalSlide,
	        trackStyle: getTrackAnimateCSS(_objectSpread({}, spec, {
	          left: animationLeft
	        })),
	        lazyLoadedList: lazyLoadedList
	      };
	      nextState = {
	        animating: false,
	        currentSlide: finalSlide,
	        trackStyle: getTrackCSS(_objectSpread({}, spec, {
	          left: finalLeft
	        })),
	        swipeLeft: null
	      };
	    }
	  }
	
	  return {
	    state: state,
	    nextState: nextState
	  };
	};
	
	exports.slideHandler = slideHandler;
	
	var changeSlide = function changeSlide(spec, options) {
	  var indexOffset, previousInt, slideOffset, unevenOffset, targetSlide;
	  var slidesToScroll = spec.slidesToScroll,
	      slidesToShow = spec.slidesToShow,
	      slideCount = spec.slideCount,
	      currentSlide = spec.currentSlide,
	      lazyLoad = spec.lazyLoad,
	      infinite = spec.infinite;
	  unevenOffset = slideCount % slidesToScroll !== 0;
	  indexOffset = unevenOffset ? 0 : (slideCount - currentSlide) % slidesToScroll;
	
	  if (options.message === "previous") {
	    slideOffset = indexOffset === 0 ? slidesToScroll : slidesToShow - indexOffset;
	    targetSlide = currentSlide - slideOffset;
	
	    if (lazyLoad && !infinite) {
	      previousInt = currentSlide - slideOffset;
	      targetSlide = previousInt === -1 ? slideCount - 1 : previousInt;
	    }
	  } else if (options.message === "next") {
	    slideOffset = indexOffset === 0 ? slidesToScroll : indexOffset;
	    targetSlide = currentSlide + slideOffset;
	
	    if (lazyLoad && !infinite) {
	      targetSlide = (currentSlide + slidesToScroll) % slideCount + indexOffset;
	    }
	  } else if (options.message === "dots") {
	    // Click on dots
	    targetSlide = options.index * options.slidesToScroll;
	
	    if (targetSlide === options.currentSlide) {
	      return null;
	    }
	  } else if (options.message === "children") {
	    // Click on the slides
	    targetSlide = options.index;
	
	    if (targetSlide === options.currentSlide) {
	      return null;
	    }
	
	    if (infinite) {
	      var direction = siblingDirection(_objectSpread({}, spec, {
	        targetSlide: targetSlide
	      }));
	
	      if (targetSlide > options.currentSlide && direction === "left") {
	        targetSlide = targetSlide - slideCount;
	      } else if (targetSlide < options.currentSlide && direction === "right") {
	        targetSlide = targetSlide + slideCount;
	      }
	    }
	  } else if (options.message === "index") {
	    targetSlide = Number(options.index);
	
	    if (targetSlide === options.currentSlide) {
	      return null;
	    }
	  }
	
	  return targetSlide;
	};
	
	exports.changeSlide = changeSlide;
	
	var keyHandler = function keyHandler(e, accessibility, rtl) {
	  if (e.target.tagName.match("TEXTAREA|INPUT|SELECT") || !accessibility) return "";
	  if (e.keyCode === 37) return rtl ? "next" : "previous";
	  if (e.keyCode === 39) return rtl ? "previous" : "next";
	  return "";
	};
	
	exports.keyHandler = keyHandler;
	
	var swipeStart = function swipeStart(e, swipe, draggable) {
	  e.target.tagName === "IMG" && e.preventDefault();
	  if (!swipe || !draggable && e.type.indexOf("mouse") !== -1) return "";
	  return {
	    dragging: true,
	    touchObject: {
	      startX: e.touches ? e.touches[0].pageX : e.clientX,
	      startY: e.touches ? e.touches[0].pageY : e.clientY,
	      curX: e.touches ? e.touches[0].pageX : e.clientX,
	      curY: e.touches ? e.touches[0].pageY : e.clientY
	    }
	  };
	};
	
	exports.swipeStart = swipeStart;
	
	var swipeMove = function swipeMove(e, spec) {
	  // spec also contains, trackRef and slideIndex
	  var scrolling = spec.scrolling,
	      animating = spec.animating,
	      vertical = spec.vertical,
	      swipeToSlide = spec.swipeToSlide,
	      verticalSwiping = spec.verticalSwiping,
	      rtl = spec.rtl,
	      currentSlide = spec.currentSlide,
	      edgeFriction = spec.edgeFriction,
	      edgeDragged = spec.edgeDragged,
	      onEdge = spec.onEdge,
	      swiped = spec.swiped,
	      swiping = spec.swiping,
	      slideCount = spec.slideCount,
	      slidesToScroll = spec.slidesToScroll,
	      infinite = spec.infinite,
	      touchObject = spec.touchObject,
	      swipeEvent = spec.swipeEvent,
	      listHeight = spec.listHeight,
	      listWidth = spec.listWidth;
	  if (scrolling) return;
	  if (animating) return e.preventDefault();
	  if (vertical && swipeToSlide && verticalSwiping) e.preventDefault();
	  var swipeLeft,
	      state = {};
	  var curLeft = getTrackLeft(spec);
	  touchObject.curX = e.touches ? e.touches[0].pageX : e.clientX;
	  touchObject.curY = e.touches ? e.touches[0].pageY : e.clientY;
	  touchObject.swipeLength = Math.round(Math.sqrt(Math.pow(touchObject.curX - touchObject.startX, 2)));
	  var verticalSwipeLength = Math.round(Math.sqrt(Math.pow(touchObject.curY - touchObject.startY, 2)));
	
	  if (!verticalSwiping && !swiping && verticalSwipeLength > 10) {
	    return {
	      scrolling: true
	    };
	  }
	
	  if (verticalSwiping) touchObject.swipeLength = verticalSwipeLength;
	  var positionOffset = (!rtl ? 1 : -1) * (touchObject.curX > touchObject.startX ? 1 : -1);
	  if (verticalSwiping) positionOffset = touchObject.curY > touchObject.startY ? 1 : -1;
	  var dotCount = Math.ceil(slideCount / slidesToScroll);
	  var swipeDirection = getSwipeDirection(spec.touchObject, verticalSwiping);
	  var touchSwipeLength = touchObject.swipeLength;
	
	  if (!infinite) {
	    if (currentSlide === 0 && swipeDirection === "right" || currentSlide + 1 >= dotCount && swipeDirection === "left" || !canGoNext(spec) && swipeDirection === "left") {
	      touchSwipeLength = touchObject.swipeLength * edgeFriction;
	
	      if (edgeDragged === false && onEdge) {
	        onEdge(swipeDirection);
	        state["edgeDragged"] = true;
	      }
	    }
	  }
	
	  if (!swiped && swipeEvent) {
	    swipeEvent(swipeDirection);
	    state["swiped"] = true;
	  }
	
	  if (!vertical) {
	    if (!rtl) {
	      swipeLeft = curLeft + touchSwipeLength * positionOffset;
	    } else {
	      swipeLeft = curLeft - touchSwipeLength * positionOffset;
	    }
	  } else {
	    swipeLeft = curLeft + touchSwipeLength * (listHeight / listWidth) * positionOffset;
	  }
	
	  if (verticalSwiping) {
	    swipeLeft = curLeft + touchSwipeLength * positionOffset;
	  }
	
	  state = _objectSpread({}, state, {
	    touchObject: touchObject,
	    swipeLeft: swipeLeft,
	    trackStyle: getTrackCSS(_objectSpread({}, spec, {
	      left: swipeLeft
	    }))
	  });
	
	  if (Math.abs(touchObject.curX - touchObject.startX) < Math.abs(touchObject.curY - touchObject.startY) * 0.8) {
	    return state;
	  }
	
	  if (touchObject.swipeLength > 10) {
	    state["swiping"] = true;
	    e.preventDefault();
	  }
	
	  return state;
	};
	
	exports.swipeMove = swipeMove;
	
	var swipeEnd = function swipeEnd(e, spec) {
	  var dragging = spec.dragging,
	      swipe = spec.swipe,
	      touchObject = spec.touchObject,
	      listWidth = spec.listWidth,
	      touchThreshold = spec.touchThreshold,
	      verticalSwiping = spec.verticalSwiping,
	      listHeight = spec.listHeight,
	      currentSlide = spec.currentSlide,
	      swipeToSlide = spec.swipeToSlide,
	      scrolling = spec.scrolling,
	      onSwipe = spec.onSwipe;
	
	  if (!dragging) {
	    if (swipe) e.preventDefault();
	    return {};
	  }
	
	  var minSwipe = verticalSwiping ? listHeight / touchThreshold : listWidth / touchThreshold;
	  var swipeDirection = getSwipeDirection(touchObject, verticalSwiping); // reset the state of touch related state variables.
	
	  var state = {
	    dragging: false,
	    edgeDragged: false,
	    scrolling: false,
	    swiping: false,
	    swiped: false,
	    swipeLeft: null,
	    touchObject: {}
	  };
	
	  if (scrolling) {
	    return state;
	  }
	
	  if (!touchObject.swipeLength) {
	    return state;
	  }
	
	  if (touchObject.swipeLength > minSwipe) {
	    e.preventDefault();
	
	    if (onSwipe) {
	      onSwipe(swipeDirection);
	    }
	
	    var slideCount, newSlide;
	
	    switch (swipeDirection) {
	      case "left":
	      case "up":
	        newSlide = currentSlide + getSlideCount(spec);
	        slideCount = swipeToSlide ? checkNavigable(spec, newSlide) : newSlide;
	        state["currentDirection"] = 0;
	        break;
	
	      case "right":
	      case "down":
	        newSlide = currentSlide - getSlideCount(spec);
	        slideCount = swipeToSlide ? checkNavigable(spec, newSlide) : newSlide;
	        state["currentDirection"] = 1;
	        break;
	
	      default:
	        slideCount = currentSlide;
	    }
	
	    state["triggerSlideHandler"] = slideCount;
	  } else {
	    // Adjust the track back to it's original position.
	    var currentLeft = getTrackLeft(spec);
	    state["trackStyle"] = getTrackAnimateCSS(_objectSpread({}, spec, {
	      left: currentLeft
	    }));
	  }
	
	  return state;
	};
	
	exports.swipeEnd = swipeEnd;
	
	var getNavigableIndexes = function getNavigableIndexes(spec) {
	  var max = spec.infinite ? spec.slideCount * 2 : spec.slideCount;
	  var breakpoint = spec.infinite ? spec.slidesToShow * -1 : 0;
	  var counter = spec.infinite ? spec.slidesToShow * -1 : 0;
	  var indexes = [];
	
	  while (breakpoint < max) {
	    indexes.push(breakpoint);
	    breakpoint = counter + spec.slidesToScroll;
	    counter += Math.min(spec.slidesToScroll, spec.slidesToShow);
	  }
	
	  return indexes;
	};
	
	exports.getNavigableIndexes = getNavigableIndexes;
	
	var checkNavigable = function checkNavigable(spec, index) {
	  var navigables = getNavigableIndexes(spec);
	  var prevNavigable = 0;
	
	  if (index > navigables[navigables.length - 1]) {
	    index = navigables[navigables.length - 1];
	  } else {
	    for (var n in navigables) {
	      if (index < navigables[n]) {
	        index = prevNavigable;
	        break;
	      }
	
	      prevNavigable = navigables[n];
	    }
	  }
	
	  return index;
	};
	
	exports.checkNavigable = checkNavigable;
	
	var getSlideCount = function getSlideCount(spec) {
	  var centerOffset = spec.centerMode ? spec.slideWidth * Math.floor(spec.slidesToShow / 2) : 0;
	
	  if (spec.swipeToSlide) {
	    var swipedSlide;
	
	    var slickList = _reactDom.default.findDOMNode(spec.listRef);
	
	    var slides = slickList.querySelectorAll(".slick-slide");
	    Array.from(slides).every(function (slide) {
	      if (!spec.vertical) {
	        if (slide.offsetLeft - centerOffset + getWidth(slide) / 2 > spec.swipeLeft * -1) {
	          swipedSlide = slide;
	          return false;
	        }
	      } else {
	        if (slide.offsetTop + getHeight(slide) / 2 > spec.swipeLeft * -1) {
	          swipedSlide = slide;
	          return false;
	        }
	      }
	
	      return true;
	    });
	
	    if (!swipedSlide) {
	      return 0;
	    }
	
	    var currentIndex = spec.rtl === true ? spec.slideCount - spec.currentSlide : spec.currentSlide;
	    var slidesTraversed = Math.abs(swipedSlide.dataset.index - currentIndex) || 1;
	    return slidesTraversed;
	  } else {
	    return spec.slidesToScroll;
	  }
	};
	
	exports.getSlideCount = getSlideCount;
	
	var checkSpecKeys = function checkSpecKeys(spec, keysArray) {
	  return keysArray.reduce(function (value, key) {
	    return value && spec.hasOwnProperty(key);
	  }, true) ? null : console.error("Keys Missing:", spec);
	};
	
	exports.checkSpecKeys = checkSpecKeys;
	
	var getTrackCSS = function getTrackCSS(spec) {
	  checkSpecKeys(spec, ["left", "variableWidth", "slideCount", "slidesToShow", "slideWidth"]);
	  var trackWidth, trackHeight;
	  var trackChildren = spec.slideCount + 2 * spec.slidesToShow;
	
	  if (!spec.vertical) {
	    trackWidth = getTotalSlides(spec) * spec.slideWidth;
	  } else {
	    trackHeight = trackChildren * spec.slideHeight;
	  }
	
	  var style = {
	    opacity: 1,
	    transition: "",
	    WebkitTransition: ""
	  };
	
	  if (spec.useTransform) {
	    var WebkitTransform = !spec.vertical ? "translate3d(" + spec.left + "px, 0px, 0px)" : "translate3d(0px, " + spec.left + "px, 0px)";
	    var transform = !spec.vertical ? "translate3d(" + spec.left + "px, 0px, 0px)" : "translate3d(0px, " + spec.left + "px, 0px)";
	    var msTransform = !spec.vertical ? "translateX(" + spec.left + "px)" : "translateY(" + spec.left + "px)";
	    style = _objectSpread({}, style, {
	      WebkitTransform: WebkitTransform,
	      transform: transform,
	      msTransform: msTransform
	    });
	  } else {
	    if (spec.vertical) {
	      style["top"] = spec.left;
	    } else {
	      style["left"] = spec.left;
	    }
	  }
	
	  if (spec.fade) style = {
	    opacity: 1
	  };
	  if (trackWidth) style.width = trackWidth;
	  if (trackHeight) style.height = trackHeight; // Fallback for IE8
	
	  if (window && !window.addEventListener && window.attachEvent) {
	    if (!spec.vertical) {
	      style.marginLeft = spec.left + "px";
	    } else {
	      style.marginTop = spec.left + "px";
	    }
	  }
	
	  return style;
	};
	
	exports.getTrackCSS = getTrackCSS;
	
	var getTrackAnimateCSS = function getTrackAnimateCSS(spec) {
	  checkSpecKeys(spec, ["left", "variableWidth", "slideCount", "slidesToShow", "slideWidth", "speed", "cssEase"]);
	  var style = getTrackCSS(spec); // useCSS is true by default so it can be undefined
	
	  if (spec.useTransform) {
	    style.WebkitTransition = "-webkit-transform " + spec.speed + "ms " + spec.cssEase;
	    style.transition = "transform " + spec.speed + "ms " + spec.cssEase;
	  } else {
	    if (spec.vertical) {
	      style.transition = "top " + spec.speed + "ms " + spec.cssEase;
	    } else {
	      style.transition = "left " + spec.speed + "ms " + spec.cssEase;
	    }
	  }
	
	  return style;
	};
	
	exports.getTrackAnimateCSS = getTrackAnimateCSS;
	
	var getTrackLeft = function getTrackLeft(spec) {
	  if (spec.unslick) {
	    return 0;
	  }
	
	  checkSpecKeys(spec, ["slideIndex", "trackRef", "infinite", "centerMode", "slideCount", "slidesToShow", "slidesToScroll", "slideWidth", "listWidth", "variableWidth", "slideHeight"]);
	  var slideIndex = spec.slideIndex,
	      trackRef = spec.trackRef,
	      infinite = spec.infinite,
	      centerMode = spec.centerMode,
	      slideCount = spec.slideCount,
	      slidesToShow = spec.slidesToShow,
	      slidesToScroll = spec.slidesToScroll,
	      slideWidth = spec.slideWidth,
	      listWidth = spec.listWidth,
	      variableWidth = spec.variableWidth,
	      slideHeight = spec.slideHeight,
	      fade = spec.fade,
	      vertical = spec.vertical;
	  var slideOffset = 0;
	  var targetLeft;
	  var targetSlide;
	  var verticalOffset = 0;
	
	  if (fade || spec.slideCount === 1) {
	    return 0;
	  }
	
	  var slidesToOffset = 0;
	
	  if (infinite) {
	    slidesToOffset = -getPreClones(spec); // bring active slide to the beginning of visual area
	    // if next scroll doesn't have enough children, just reach till the end of original slides instead of shifting slidesToScroll children
	
	    if (slideCount % slidesToScroll !== 0 && slideIndex + slidesToScroll > slideCount) {
	      slidesToOffset = -(slideIndex > slideCount ? slidesToShow - (slideIndex - slideCount) : slideCount % slidesToScroll);
	    } // shift current slide to center of the frame
	
	
	    if (centerMode) {
	      slidesToOffset += parseInt(slidesToShow / 2);
	    }
	  } else {
	    if (slideCount % slidesToScroll !== 0 && slideIndex + slidesToScroll > slideCount) {
	      slidesToOffset = slidesToShow - slideCount % slidesToScroll;
	    }
	
	    if (centerMode) {
	      slidesToOffset = parseInt(slidesToShow / 2);
	    }
	  }
	
	  slideOffset = slidesToOffset * slideWidth;
	  verticalOffset = slidesToOffset * slideHeight;
	
	  if (!vertical) {
	    targetLeft = slideIndex * slideWidth * -1 + slideOffset;
	  } else {
	    targetLeft = slideIndex * slideHeight * -1 + verticalOffset;
	  }
	
	  if (variableWidth === true) {
	    var targetSlideIndex;
	
	    var trackElem = _reactDom.default.findDOMNode(trackRef);
	
	    targetSlideIndex = slideIndex + getPreClones(spec);
	    targetSlide = trackElem && trackElem.childNodes[targetSlideIndex];
	    targetLeft = targetSlide ? targetSlide.offsetLeft * -1 : 0;
	
	    if (centerMode === true) {
	      targetSlideIndex = infinite ? slideIndex + getPreClones(spec) : slideIndex;
	      targetSlide = trackElem && trackElem.children[targetSlideIndex];
	      targetLeft = 0;
	
	      for (var slide = 0; slide < targetSlideIndex; slide++) {
	        targetLeft -= trackElem && trackElem.children[slide] && trackElem.children[slide].offsetWidth;
	      }
	
	      targetLeft -= parseInt(spec.centerPadding);
	      targetLeft += targetSlide && (listWidth - targetSlide.offsetWidth) / 2;
	    }
	  }
	
	  return targetLeft;
	};
	
	exports.getTrackLeft = getTrackLeft;
	
	var getPreClones = function getPreClones(spec) {
	  if (spec.unslick || !spec.infinite) {
	    return 0;
	  }
	
	  if (spec.variableWidth) {
	    return spec.slideCount;
	  }
	
	  return spec.slidesToShow + (spec.centerMode ? 1 : 0);
	};
	
	exports.getPreClones = getPreClones;
	
	var getPostClones = function getPostClones(spec) {
	  if (spec.unslick || !spec.infinite) {
	    return 0;
	  }
	
	  return spec.slideCount;
	};
	
	exports.getPostClones = getPostClones;
	
	var getTotalSlides = function getTotalSlides(spec) {
	  return spec.slideCount === 1 ? 1 : getPreClones(spec) + spec.slideCount + getPostClones(spec);
	};
	
	exports.getTotalSlides = getTotalSlides;
	
	var siblingDirection = function siblingDirection(spec) {
	  if (spec.targetSlide > spec.currentSlide) {
	    if (spec.targetSlide > spec.currentSlide + slidesOnRight(spec)) {
	      return "left";
	    }
	
	    return "right";
	  } else {
	    if (spec.targetSlide < spec.currentSlide - slidesOnLeft(spec)) {
	      return "right";
	    }
	
	    return "left";
	  }
	};
	
	exports.siblingDirection = siblingDirection;
	
	var slidesOnRight = function slidesOnRight(_ref) {
	  var slidesToShow = _ref.slidesToShow,
	      centerMode = _ref.centerMode,
	      rtl = _ref.rtl,
	      centerPadding = _ref.centerPadding;
	
	  // returns no of slides on the right of active slide
	  if (centerMode) {
	    var right = (slidesToShow - 1) / 2 + 1;
	    if (parseInt(centerPadding) > 0) right += 1;
	    if (rtl && slidesToShow % 2 === 0) right += 1;
	    return right;
	  }
	
	  if (rtl) {
	    return 0;
	  }
	
	  return slidesToShow - 1;
	};
	
	exports.slidesOnRight = slidesOnRight;
	
	var slidesOnLeft = function slidesOnLeft(_ref2) {
	  var slidesToShow = _ref2.slidesToShow,
	      centerMode = _ref2.centerMode,
	      rtl = _ref2.rtl,
	      centerPadding = _ref2.centerPadding;
	
	  // returns no of slides on the left of active slide
	  if (centerMode) {
	    var left = (slidesToShow - 1) / 2 + 1;
	    if (parseInt(centerPadding) > 0) left += 1;
	    if (!rtl && slidesToShow % 2 === 0) left += 1;
	    return left;
	  }
	
	  if (rtl) {
	    return slidesToShow - 1;
	  }
	
	  return 0;
	};
	
	exports.slidesOnLeft = slidesOnLeft;
	
	var canUseDOM = function canUseDOM() {
	  return !!(typeof window !== "undefined" && window.document && window.document.createElement);
	};
	
	exports.canUseDOM = canUseDOM;

/***/ }),

/***/ 343:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {(function (global, factory) {
	     true ? module.exports = factory() :
	    typeof define === 'function' && define.amd ? define(factory) :
	    (global.ResizeObserver = factory());
	}(this, (function () { 'use strict';
	
	    /**
	     * A collection of shims that provide minimal functionality of the ES6 collections.
	     *
	     * These implementations are not meant to be used outside of the ResizeObserver
	     * modules as they cover only a limited range of use cases.
	     */
	    /* eslint-disable require-jsdoc, valid-jsdoc */
	    var MapShim = (function () {
	        if (typeof Map !== 'undefined') {
	            return Map;
	        }
	        /**
	         * Returns index in provided array that matches the specified key.
	         *
	         * @param {Array<Array>} arr
	         * @param {*} key
	         * @returns {number}
	         */
	        function getIndex(arr, key) {
	            var result = -1;
	            arr.some(function (entry, index) {
	                if (entry[0] === key) {
	                    result = index;
	                    return true;
	                }
	                return false;
	            });
	            return result;
	        }
	        return /** @class */ (function () {
	            function class_1() {
	                this.__entries__ = [];
	            }
	            Object.defineProperty(class_1.prototype, "size", {
	                /**
	                 * @returns {boolean}
	                 */
	                get: function () {
	                    return this.__entries__.length;
	                },
	                enumerable: true,
	                configurable: true
	            });
	            /**
	             * @param {*} key
	             * @returns {*}
	             */
	            class_1.prototype.get = function (key) {
	                var index = getIndex(this.__entries__, key);
	                var entry = this.__entries__[index];
	                return entry && entry[1];
	            };
	            /**
	             * @param {*} key
	             * @param {*} value
	             * @returns {void}
	             */
	            class_1.prototype.set = function (key, value) {
	                var index = getIndex(this.__entries__, key);
	                if (~index) {
	                    this.__entries__[index][1] = value;
	                }
	                else {
	                    this.__entries__.push([key, value]);
	                }
	            };
	            /**
	             * @param {*} key
	             * @returns {void}
	             */
	            class_1.prototype.delete = function (key) {
	                var entries = this.__entries__;
	                var index = getIndex(entries, key);
	                if (~index) {
	                    entries.splice(index, 1);
	                }
	            };
	            /**
	             * @param {*} key
	             * @returns {void}
	             */
	            class_1.prototype.has = function (key) {
	                return !!~getIndex(this.__entries__, key);
	            };
	            /**
	             * @returns {void}
	             */
	            class_1.prototype.clear = function () {
	                this.__entries__.splice(0);
	            };
	            /**
	             * @param {Function} callback
	             * @param {*} [ctx=null]
	             * @returns {void}
	             */
	            class_1.prototype.forEach = function (callback, ctx) {
	                if (ctx === void 0) { ctx = null; }
	                for (var _i = 0, _a = this.__entries__; _i < _a.length; _i++) {
	                    var entry = _a[_i];
	                    callback.call(ctx, entry[1], entry[0]);
	                }
	            };
	            return class_1;
	        }());
	    })();
	
	    /**
	     * Detects whether window and document objects are available in current environment.
	     */
	    var isBrowser = typeof window !== 'undefined' && typeof document !== 'undefined' && window.document === document;
	
	    // Returns global object of a current environment.
	    var global$1 = (function () {
	        if (typeof global !== 'undefined' && global.Math === Math) {
	            return global;
	        }
	        if (typeof self !== 'undefined' && self.Math === Math) {
	            return self;
	        }
	        if (typeof window !== 'undefined' && window.Math === Math) {
	            return window;
	        }
	        // eslint-disable-next-line no-new-func
	        return Function('return this')();
	    })();
	
	    /**
	     * A shim for the requestAnimationFrame which falls back to the setTimeout if
	     * first one is not supported.
	     *
	     * @returns {number} Requests' identifier.
	     */
	    var requestAnimationFrame$1 = (function () {
	        if (typeof requestAnimationFrame === 'function') {
	            // It's required to use a bounded function because IE sometimes throws
	            // an "Invalid calling object" error if rAF is invoked without the global
	            // object on the left hand side.
	            return requestAnimationFrame.bind(global$1);
	        }
	        return function (callback) { return setTimeout(function () { return callback(Date.now()); }, 1000 / 60); };
	    })();
	
	    // Defines minimum timeout before adding a trailing call.
	    var trailingTimeout = 2;
	    /**
	     * Creates a wrapper function which ensures that provided callback will be
	     * invoked only once during the specified delay period.
	     *
	     * @param {Function} callback - Function to be invoked after the delay period.
	     * @param {number} delay - Delay after which to invoke callback.
	     * @returns {Function}
	     */
	    function throttle (callback, delay) {
	        var leadingCall = false, trailingCall = false, lastCallTime = 0;
	        /**
	         * Invokes the original callback function and schedules new invocation if
	         * the "proxy" was called during current request.
	         *
	         * @returns {void}
	         */
	        function resolvePending() {
	            if (leadingCall) {
	                leadingCall = false;
	                callback();
	            }
	            if (trailingCall) {
	                proxy();
	            }
	        }
	        /**
	         * Callback invoked after the specified delay. It will further postpone
	         * invocation of the original function delegating it to the
	         * requestAnimationFrame.
	         *
	         * @returns {void}
	         */
	        function timeoutCallback() {
	            requestAnimationFrame$1(resolvePending);
	        }
	        /**
	         * Schedules invocation of the original function.
	         *
	         * @returns {void}
	         */
	        function proxy() {
	            var timeStamp = Date.now();
	            if (leadingCall) {
	                // Reject immediately following calls.
	                if (timeStamp - lastCallTime < trailingTimeout) {
	                    return;
	                }
	                // Schedule new call to be in invoked when the pending one is resolved.
	                // This is important for "transitions" which never actually start
	                // immediately so there is a chance that we might miss one if change
	                // happens amids the pending invocation.
	                trailingCall = true;
	            }
	            else {
	                leadingCall = true;
	                trailingCall = false;
	                setTimeout(timeoutCallback, delay);
	            }
	            lastCallTime = timeStamp;
	        }
	        return proxy;
	    }
	
	    // Minimum delay before invoking the update of observers.
	    var REFRESH_DELAY = 20;
	    // A list of substrings of CSS properties used to find transition events that
	    // might affect dimensions of observed elements.
	    var transitionKeys = ['top', 'right', 'bottom', 'left', 'width', 'height', 'size', 'weight'];
	    // Check if MutationObserver is available.
	    var mutationObserverSupported = typeof MutationObserver !== 'undefined';
	    /**
	     * Singleton controller class which handles updates of ResizeObserver instances.
	     */
	    var ResizeObserverController = /** @class */ (function () {
	        /**
	         * Creates a new instance of ResizeObserverController.
	         *
	         * @private
	         */
	        function ResizeObserverController() {
	            /**
	             * Indicates whether DOM listeners have been added.
	             *
	             * @private {boolean}
	             */
	            this.connected_ = false;
	            /**
	             * Tells that controller has subscribed for Mutation Events.
	             *
	             * @private {boolean}
	             */
	            this.mutationEventsAdded_ = false;
	            /**
	             * Keeps reference to the instance of MutationObserver.
	             *
	             * @private {MutationObserver}
	             */
	            this.mutationsObserver_ = null;
	            /**
	             * A list of connected observers.
	             *
	             * @private {Array<ResizeObserverSPI>}
	             */
	            this.observers_ = [];
	            this.onTransitionEnd_ = this.onTransitionEnd_.bind(this);
	            this.refresh = throttle(this.refresh.bind(this), REFRESH_DELAY);
	        }
	        /**
	         * Adds observer to observers list.
	         *
	         * @param {ResizeObserverSPI} observer - Observer to be added.
	         * @returns {void}
	         */
	        ResizeObserverController.prototype.addObserver = function (observer) {
	            if (!~this.observers_.indexOf(observer)) {
	                this.observers_.push(observer);
	            }
	            // Add listeners if they haven't been added yet.
	            if (!this.connected_) {
	                this.connect_();
	            }
	        };
	        /**
	         * Removes observer from observers list.
	         *
	         * @param {ResizeObserverSPI} observer - Observer to be removed.
	         * @returns {void}
	         */
	        ResizeObserverController.prototype.removeObserver = function (observer) {
	            var observers = this.observers_;
	            var index = observers.indexOf(observer);
	            // Remove observer if it's present in registry.
	            if (~index) {
	                observers.splice(index, 1);
	            }
	            // Remove listeners if controller has no connected observers.
	            if (!observers.length && this.connected_) {
	                this.disconnect_();
	            }
	        };
	        /**
	         * Invokes the update of observers. It will continue running updates insofar
	         * it detects changes.
	         *
	         * @returns {void}
	         */
	        ResizeObserverController.prototype.refresh = function () {
	            var changesDetected = this.updateObservers_();
	            // Continue running updates if changes have been detected as there might
	            // be future ones caused by CSS transitions.
	            if (changesDetected) {
	                this.refresh();
	            }
	        };
	        /**
	         * Updates every observer from observers list and notifies them of queued
	         * entries.
	         *
	         * @private
	         * @returns {boolean} Returns "true" if any observer has detected changes in
	         *      dimensions of it's elements.
	         */
	        ResizeObserverController.prototype.updateObservers_ = function () {
	            // Collect observers that have active observations.
	            var activeObservers = this.observers_.filter(function (observer) {
	                return observer.gatherActive(), observer.hasActive();
	            });
	            // Deliver notifications in a separate cycle in order to avoid any
	            // collisions between observers, e.g. when multiple instances of
	            // ResizeObserver are tracking the same element and the callback of one
	            // of them changes content dimensions of the observed target. Sometimes
	            // this may result in notifications being blocked for the rest of observers.
	            activeObservers.forEach(function (observer) { return observer.broadcastActive(); });
	            return activeObservers.length > 0;
	        };
	        /**
	         * Initializes DOM listeners.
	         *
	         * @private
	         * @returns {void}
	         */
	        ResizeObserverController.prototype.connect_ = function () {
	            // Do nothing if running in a non-browser environment or if listeners
	            // have been already added.
	            if (!isBrowser || this.connected_) {
	                return;
	            }
	            // Subscription to the "Transitionend" event is used as a workaround for
	            // delayed transitions. This way it's possible to capture at least the
	            // final state of an element.
	            document.addEventListener('transitionend', this.onTransitionEnd_);
	            window.addEventListener('resize', this.refresh);
	            if (mutationObserverSupported) {
	                this.mutationsObserver_ = new MutationObserver(this.refresh);
	                this.mutationsObserver_.observe(document, {
	                    attributes: true,
	                    childList: true,
	                    characterData: true,
	                    subtree: true
	                });
	            }
	            else {
	                document.addEventListener('DOMSubtreeModified', this.refresh);
	                this.mutationEventsAdded_ = true;
	            }
	            this.connected_ = true;
	        };
	        /**
	         * Removes DOM listeners.
	         *
	         * @private
	         * @returns {void}
	         */
	        ResizeObserverController.prototype.disconnect_ = function () {
	            // Do nothing if running in a non-browser environment or if listeners
	            // have been already removed.
	            if (!isBrowser || !this.connected_) {
	                return;
	            }
	            document.removeEventListener('transitionend', this.onTransitionEnd_);
	            window.removeEventListener('resize', this.refresh);
	            if (this.mutationsObserver_) {
	                this.mutationsObserver_.disconnect();
	            }
	            if (this.mutationEventsAdded_) {
	                document.removeEventListener('DOMSubtreeModified', this.refresh);
	            }
	            this.mutationsObserver_ = null;
	            this.mutationEventsAdded_ = false;
	            this.connected_ = false;
	        };
	        /**
	         * "Transitionend" event handler.
	         *
	         * @private
	         * @param {TransitionEvent} event
	         * @returns {void}
	         */
	        ResizeObserverController.prototype.onTransitionEnd_ = function (_a) {
	            var _b = _a.propertyName, propertyName = _b === void 0 ? '' : _b;
	            // Detect whether transition may affect dimensions of an element.
	            var isReflowProperty = transitionKeys.some(function (key) {
	                return !!~propertyName.indexOf(key);
	            });
	            if (isReflowProperty) {
	                this.refresh();
	            }
	        };
	        /**
	         * Returns instance of the ResizeObserverController.
	         *
	         * @returns {ResizeObserverController}
	         */
	        ResizeObserverController.getInstance = function () {
	            if (!this.instance_) {
	                this.instance_ = new ResizeObserverController();
	            }
	            return this.instance_;
	        };
	        /**
	         * Holds reference to the controller's instance.
	         *
	         * @private {ResizeObserverController}
	         */
	        ResizeObserverController.instance_ = null;
	        return ResizeObserverController;
	    }());
	
	    /**
	     * Defines non-writable/enumerable properties of the provided target object.
	     *
	     * @param {Object} target - Object for which to define properties.
	     * @param {Object} props - Properties to be defined.
	     * @returns {Object} Target object.
	     */
	    var defineConfigurable = (function (target, props) {
	        for (var _i = 0, _a = Object.keys(props); _i < _a.length; _i++) {
	            var key = _a[_i];
	            Object.defineProperty(target, key, {
	                value: props[key],
	                enumerable: false,
	                writable: false,
	                configurable: true
	            });
	        }
	        return target;
	    });
	
	    /**
	     * Returns the global object associated with provided element.
	     *
	     * @param {Object} target
	     * @returns {Object}
	     */
	    var getWindowOf = (function (target) {
	        // Assume that the element is an instance of Node, which means that it
	        // has the "ownerDocument" property from which we can retrieve a
	        // corresponding global object.
	        var ownerGlobal = target && target.ownerDocument && target.ownerDocument.defaultView;
	        // Return the local global object if it's not possible extract one from
	        // provided element.
	        return ownerGlobal || global$1;
	    });
	
	    // Placeholder of an empty content rectangle.
	    var emptyRect = createRectInit(0, 0, 0, 0);
	    /**
	     * Converts provided string to a number.
	     *
	     * @param {number|string} value
	     * @returns {number}
	     */
	    function toFloat(value) {
	        return parseFloat(value) || 0;
	    }
	    /**
	     * Extracts borders size from provided styles.
	     *
	     * @param {CSSStyleDeclaration} styles
	     * @param {...string} positions - Borders positions (top, right, ...)
	     * @returns {number}
	     */
	    function getBordersSize(styles) {
	        var positions = [];
	        for (var _i = 1; _i < arguments.length; _i++) {
	            positions[_i - 1] = arguments[_i];
	        }
	        return positions.reduce(function (size, position) {
	            var value = styles['border-' + position + '-width'];
	            return size + toFloat(value);
	        }, 0);
	    }
	    /**
	     * Extracts paddings sizes from provided styles.
	     *
	     * @param {CSSStyleDeclaration} styles
	     * @returns {Object} Paddings box.
	     */
	    function getPaddings(styles) {
	        var positions = ['top', 'right', 'bottom', 'left'];
	        var paddings = {};
	        for (var _i = 0, positions_1 = positions; _i < positions_1.length; _i++) {
	            var position = positions_1[_i];
	            var value = styles['padding-' + position];
	            paddings[position] = toFloat(value);
	        }
	        return paddings;
	    }
	    /**
	     * Calculates content rectangle of provided SVG element.
	     *
	     * @param {SVGGraphicsElement} target - Element content rectangle of which needs
	     *      to be calculated.
	     * @returns {DOMRectInit}
	     */
	    function getSVGContentRect(target) {
	        var bbox = target.getBBox();
	        return createRectInit(0, 0, bbox.width, bbox.height);
	    }
	    /**
	     * Calculates content rectangle of provided HTMLElement.
	     *
	     * @param {HTMLElement} target - Element for which to calculate the content rectangle.
	     * @returns {DOMRectInit}
	     */
	    function getHTMLElementContentRect(target) {
	        // Client width & height properties can't be
	        // used exclusively as they provide rounded values.
	        var clientWidth = target.clientWidth, clientHeight = target.clientHeight;
	        // By this condition we can catch all non-replaced inline, hidden and
	        // detached elements. Though elements with width & height properties less
	        // than 0.5 will be discarded as well.
	        //
	        // Without it we would need to implement separate methods for each of
	        // those cases and it's not possible to perform a precise and performance
	        // effective test for hidden elements. E.g. even jQuery's ':visible' filter
	        // gives wrong results for elements with width & height less than 0.5.
	        if (!clientWidth && !clientHeight) {
	            return emptyRect;
	        }
	        var styles = getWindowOf(target).getComputedStyle(target);
	        var paddings = getPaddings(styles);
	        var horizPad = paddings.left + paddings.right;
	        var vertPad = paddings.top + paddings.bottom;
	        // Computed styles of width & height are being used because they are the
	        // only dimensions available to JS that contain non-rounded values. It could
	        // be possible to utilize the getBoundingClientRect if only it's data wasn't
	        // affected by CSS transformations let alone paddings, borders and scroll bars.
	        var width = toFloat(styles.width), height = toFloat(styles.height);
	        // Width & height include paddings and borders when the 'border-box' box
	        // model is applied (except for IE).
	        if (styles.boxSizing === 'border-box') {
	            // Following conditions are required to handle Internet Explorer which
	            // doesn't include paddings and borders to computed CSS dimensions.
	            //
	            // We can say that if CSS dimensions + paddings are equal to the "client"
	            // properties then it's either IE, and thus we don't need to subtract
	            // anything, or an element merely doesn't have paddings/borders styles.
	            if (Math.round(width + horizPad) !== clientWidth) {
	                width -= getBordersSize(styles, 'left', 'right') + horizPad;
	            }
	            if (Math.round(height + vertPad) !== clientHeight) {
	                height -= getBordersSize(styles, 'top', 'bottom') + vertPad;
	            }
	        }
	        // Following steps can't be applied to the document's root element as its
	        // client[Width/Height] properties represent viewport area of the window.
	        // Besides, it's as well not necessary as the <html> itself neither has
	        // rendered scroll bars nor it can be clipped.
	        if (!isDocumentElement(target)) {
	            // In some browsers (only in Firefox, actually) CSS width & height
	            // include scroll bars size which can be removed at this step as scroll
	            // bars are the only difference between rounded dimensions + paddings
	            // and "client" properties, though that is not always true in Chrome.
	            var vertScrollbar = Math.round(width + horizPad) - clientWidth;
	            var horizScrollbar = Math.round(height + vertPad) - clientHeight;
	            // Chrome has a rather weird rounding of "client" properties.
	            // E.g. for an element with content width of 314.2px it sometimes gives
	            // the client width of 315px and for the width of 314.7px it may give
	            // 314px. And it doesn't happen all the time. So just ignore this delta
	            // as a non-relevant.
	            if (Math.abs(vertScrollbar) !== 1) {
	                width -= vertScrollbar;
	            }
	            if (Math.abs(horizScrollbar) !== 1) {
	                height -= horizScrollbar;
	            }
	        }
	        return createRectInit(paddings.left, paddings.top, width, height);
	    }
	    /**
	     * Checks whether provided element is an instance of the SVGGraphicsElement.
	     *
	     * @param {Element} target - Element to be checked.
	     * @returns {boolean}
	     */
	    var isSVGGraphicsElement = (function () {
	        // Some browsers, namely IE and Edge, don't have the SVGGraphicsElement
	        // interface.
	        if (typeof SVGGraphicsElement !== 'undefined') {
	            return function (target) { return target instanceof getWindowOf(target).SVGGraphicsElement; };
	        }
	        // If it's so, then check that element is at least an instance of the
	        // SVGElement and that it has the "getBBox" method.
	        // eslint-disable-next-line no-extra-parens
	        return function (target) { return (target instanceof getWindowOf(target).SVGElement &&
	            typeof target.getBBox === 'function'); };
	    })();
	    /**
	     * Checks whether provided element is a document element (<html>).
	     *
	     * @param {Element} target - Element to be checked.
	     * @returns {boolean}
	     */
	    function isDocumentElement(target) {
	        return target === getWindowOf(target).document.documentElement;
	    }
	    /**
	     * Calculates an appropriate content rectangle for provided html or svg element.
	     *
	     * @param {Element} target - Element content rectangle of which needs to be calculated.
	     * @returns {DOMRectInit}
	     */
	    function getContentRect(target) {
	        if (!isBrowser) {
	            return emptyRect;
	        }
	        if (isSVGGraphicsElement(target)) {
	            return getSVGContentRect(target);
	        }
	        return getHTMLElementContentRect(target);
	    }
	    /**
	     * Creates rectangle with an interface of the DOMRectReadOnly.
	     * Spec: https://drafts.fxtf.org/geometry/#domrectreadonly
	     *
	     * @param {DOMRectInit} rectInit - Object with rectangle's x/y coordinates and dimensions.
	     * @returns {DOMRectReadOnly}
	     */
	    function createReadOnlyRect(_a) {
	        var x = _a.x, y = _a.y, width = _a.width, height = _a.height;
	        // If DOMRectReadOnly is available use it as a prototype for the rectangle.
	        var Constr = typeof DOMRectReadOnly !== 'undefined' ? DOMRectReadOnly : Object;
	        var rect = Object.create(Constr.prototype);
	        // Rectangle's properties are not writable and non-enumerable.
	        defineConfigurable(rect, {
	            x: x, y: y, width: width, height: height,
	            top: y,
	            right: x + width,
	            bottom: height + y,
	            left: x
	        });
	        return rect;
	    }
	    /**
	     * Creates DOMRectInit object based on the provided dimensions and the x/y coordinates.
	     * Spec: https://drafts.fxtf.org/geometry/#dictdef-domrectinit
	     *
	     * @param {number} x - X coordinate.
	     * @param {number} y - Y coordinate.
	     * @param {number} width - Rectangle's width.
	     * @param {number} height - Rectangle's height.
	     * @returns {DOMRectInit}
	     */
	    function createRectInit(x, y, width, height) {
	        return { x: x, y: y, width: width, height: height };
	    }
	
	    /**
	     * Class that is responsible for computations of the content rectangle of
	     * provided DOM element and for keeping track of it's changes.
	     */
	    var ResizeObservation = /** @class */ (function () {
	        /**
	         * Creates an instance of ResizeObservation.
	         *
	         * @param {Element} target - Element to be observed.
	         */
	        function ResizeObservation(target) {
	            /**
	             * Broadcasted width of content rectangle.
	             *
	             * @type {number}
	             */
	            this.broadcastWidth = 0;
	            /**
	             * Broadcasted height of content rectangle.
	             *
	             * @type {number}
	             */
	            this.broadcastHeight = 0;
	            /**
	             * Reference to the last observed content rectangle.
	             *
	             * @private {DOMRectInit}
	             */
	            this.contentRect_ = createRectInit(0, 0, 0, 0);
	            this.target = target;
	        }
	        /**
	         * Updates content rectangle and tells whether it's width or height properties
	         * have changed since the last broadcast.
	         *
	         * @returns {boolean}
	         */
	        ResizeObservation.prototype.isActive = function () {
	            var rect = getContentRect(this.target);
	            this.contentRect_ = rect;
	            return (rect.width !== this.broadcastWidth ||
	                rect.height !== this.broadcastHeight);
	        };
	        /**
	         * Updates 'broadcastWidth' and 'broadcastHeight' properties with a data
	         * from the corresponding properties of the last observed content rectangle.
	         *
	         * @returns {DOMRectInit} Last observed content rectangle.
	         */
	        ResizeObservation.prototype.broadcastRect = function () {
	            var rect = this.contentRect_;
	            this.broadcastWidth = rect.width;
	            this.broadcastHeight = rect.height;
	            return rect;
	        };
	        return ResizeObservation;
	    }());
	
	    var ResizeObserverEntry = /** @class */ (function () {
	        /**
	         * Creates an instance of ResizeObserverEntry.
	         *
	         * @param {Element} target - Element that is being observed.
	         * @param {DOMRectInit} rectInit - Data of the element's content rectangle.
	         */
	        function ResizeObserverEntry(target, rectInit) {
	            var contentRect = createReadOnlyRect(rectInit);
	            // According to the specification following properties are not writable
	            // and are also not enumerable in the native implementation.
	            //
	            // Property accessors are not being used as they'd require to define a
	            // private WeakMap storage which may cause memory leaks in browsers that
	            // don't support this type of collections.
	            defineConfigurable(this, { target: target, contentRect: contentRect });
	        }
	        return ResizeObserverEntry;
	    }());
	
	    var ResizeObserverSPI = /** @class */ (function () {
	        /**
	         * Creates a new instance of ResizeObserver.
	         *
	         * @param {ResizeObserverCallback} callback - Callback function that is invoked
	         *      when one of the observed elements changes it's content dimensions.
	         * @param {ResizeObserverController} controller - Controller instance which
	         *      is responsible for the updates of observer.
	         * @param {ResizeObserver} callbackCtx - Reference to the public
	         *      ResizeObserver instance which will be passed to callback function.
	         */
	        function ResizeObserverSPI(callback, controller, callbackCtx) {
	            /**
	             * Collection of resize observations that have detected changes in dimensions
	             * of elements.
	             *
	             * @private {Array<ResizeObservation>}
	             */
	            this.activeObservations_ = [];
	            /**
	             * Registry of the ResizeObservation instances.
	             *
	             * @private {Map<Element, ResizeObservation>}
	             */
	            this.observations_ = new MapShim();
	            if (typeof callback !== 'function') {
	                throw new TypeError('The callback provided as parameter 1 is not a function.');
	            }
	            this.callback_ = callback;
	            this.controller_ = controller;
	            this.callbackCtx_ = callbackCtx;
	        }
	        /**
	         * Starts observing provided element.
	         *
	         * @param {Element} target - Element to be observed.
	         * @returns {void}
	         */
	        ResizeObserverSPI.prototype.observe = function (target) {
	            if (!arguments.length) {
	                throw new TypeError('1 argument required, but only 0 present.');
	            }
	            // Do nothing if current environment doesn't have the Element interface.
	            if (typeof Element === 'undefined' || !(Element instanceof Object)) {
	                return;
	            }
	            if (!(target instanceof getWindowOf(target).Element)) {
	                throw new TypeError('parameter 1 is not of type "Element".');
	            }
	            var observations = this.observations_;
	            // Do nothing if element is already being observed.
	            if (observations.has(target)) {
	                return;
	            }
	            observations.set(target, new ResizeObservation(target));
	            this.controller_.addObserver(this);
	            // Force the update of observations.
	            this.controller_.refresh();
	        };
	        /**
	         * Stops observing provided element.
	         *
	         * @param {Element} target - Element to stop observing.
	         * @returns {void}
	         */
	        ResizeObserverSPI.prototype.unobserve = function (target) {
	            if (!arguments.length) {
	                throw new TypeError('1 argument required, but only 0 present.');
	            }
	            // Do nothing if current environment doesn't have the Element interface.
	            if (typeof Element === 'undefined' || !(Element instanceof Object)) {
	                return;
	            }
	            if (!(target instanceof getWindowOf(target).Element)) {
	                throw new TypeError('parameter 1 is not of type "Element".');
	            }
	            var observations = this.observations_;
	            // Do nothing if element is not being observed.
	            if (!observations.has(target)) {
	                return;
	            }
	            observations.delete(target);
	            if (!observations.size) {
	                this.controller_.removeObserver(this);
	            }
	        };
	        /**
	         * Stops observing all elements.
	         *
	         * @returns {void}
	         */
	        ResizeObserverSPI.prototype.disconnect = function () {
	            this.clearActive();
	            this.observations_.clear();
	            this.controller_.removeObserver(this);
	        };
	        /**
	         * Collects observation instances the associated element of which has changed
	         * it's content rectangle.
	         *
	         * @returns {void}
	         */
	        ResizeObserverSPI.prototype.gatherActive = function () {
	            var _this = this;
	            this.clearActive();
	            this.observations_.forEach(function (observation) {
	                if (observation.isActive()) {
	                    _this.activeObservations_.push(observation);
	                }
	            });
	        };
	        /**
	         * Invokes initial callback function with a list of ResizeObserverEntry
	         * instances collected from active resize observations.
	         *
	         * @returns {void}
	         */
	        ResizeObserverSPI.prototype.broadcastActive = function () {
	            // Do nothing if observer doesn't have active observations.
	            if (!this.hasActive()) {
	                return;
	            }
	            var ctx = this.callbackCtx_;
	            // Create ResizeObserverEntry instance for every active observation.
	            var entries = this.activeObservations_.map(function (observation) {
	                return new ResizeObserverEntry(observation.target, observation.broadcastRect());
	            });
	            this.callback_.call(ctx, entries, ctx);
	            this.clearActive();
	        };
	        /**
	         * Clears the collection of active observations.
	         *
	         * @returns {void}
	         */
	        ResizeObserverSPI.prototype.clearActive = function () {
	            this.activeObservations_.splice(0);
	        };
	        /**
	         * Tells whether observer has active observations.
	         *
	         * @returns {boolean}
	         */
	        ResizeObserverSPI.prototype.hasActive = function () {
	            return this.activeObservations_.length > 0;
	        };
	        return ResizeObserverSPI;
	    }());
	
	    // Registry of internal observers. If WeakMap is not available use current shim
	    // for the Map collection as it has all required methods and because WeakMap
	    // can't be fully polyfilled anyway.
	    var observers = typeof WeakMap !== 'undefined' ? new WeakMap() : new MapShim();
	    /**
	     * ResizeObserver API. Encapsulates the ResizeObserver SPI implementation
	     * exposing only those methods and properties that are defined in the spec.
	     */
	    var ResizeObserver = /** @class */ (function () {
	        /**
	         * Creates a new instance of ResizeObserver.
	         *
	         * @param {ResizeObserverCallback} callback - Callback that is invoked when
	         *      dimensions of the observed elements change.
	         */
	        function ResizeObserver(callback) {
	            if (!(this instanceof ResizeObserver)) {
	                throw new TypeError('Cannot call a class as a function.');
	            }
	            if (!arguments.length) {
	                throw new TypeError('1 argument required, but only 0 present.');
	            }
	            var controller = ResizeObserverController.getInstance();
	            var observer = new ResizeObserverSPI(callback, controller, this);
	            observers.set(this, observer);
	        }
	        return ResizeObserver;
	    }());
	    // Expose public methods of ResizeObserver.
	    [
	        'observe',
	        'unobserve',
	        'disconnect'
	    ].forEach(function (method) {
	        ResizeObserver.prototype[method] = function () {
	            var _a;
	            return (_a = observers.get(this))[method].apply(_a, arguments);
	        };
	    });
	
	    var index = (function () {
	        // Export existing implementation if available.
	        if (typeof global$1.ResizeObserver !== 'undefined') {
	            return global$1.ResizeObserver;
	        }
	        return ResizeObserver;
	    })();
	
	    return index;
	
	})));
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),

/***/ 257:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 258:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 349:
/***/ (function(module, exports) {

	var camel2hyphen = function (str) {
	  return str
	          .replace(/[A-Z]/g, function (match) {
	            return '-' + match.toLowerCase();
	          })
	          .toLowerCase();
	};
	
	module.exports = camel2hyphen;

/***/ }),

/***/ 350:
/***/ (function(module, exports) {

	exports.isatty = function () { return false; };
	
	function ReadStream() {
	  throw new Error('tty.ReadStream is not implemented');
	}
	exports.ReadStream = ReadStream;
	
	function WriteStream() {
	  throw new Error('tty.ReadStream is not implemented');
	}
	exports.WriteStream = WriteStream;


/***/ }),

/***/ 371:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/*
	 * window-size
	 * https://github.com/jonschlinkert/window-size
	 *
	 * Copyright (c) 2014 Jon Schlinkert
	 * Licensed under the MIT license.
	 */
	
	const tty = __webpack_require__(350)
	
	module.exports = (function() {
	  var width;
	  var height;
	
	  if(tty.isatty(1) && tty.isatty(2)) {
	    if(process.stdout.getWindowSize) {
	      width = process.stdout.getWindowSize(1)[0];
	      height = process.stdout.getWindowSize(1)[1];
	    } else if (tty.getWindowSize) {
	      width = tty.getWindowSize()[1];
	      height = tty.getWindowSize()[0];
	    } else if (process.stdout.columns && process.stdout.rows) {
	      height = process.stdout.columns;
	      width = process.stdout.rows;
	    }
	  } else {
	    new Error('Error: could not get window size with tty or process.stdout');
	  }
	  return {
	    height: height,
	    width: width
	  }
	})();
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(90)))

/***/ }),

/***/ 148:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(8);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _gatsbyImage = __webpack_require__(83);
	
	var _gatsbyImage2 = _interopRequireDefault(_gatsbyImage);
	
	var _reactSlick = __webpack_require__(337);
	
	var _reactSlick2 = _interopRequireDefault(_reactSlick);
	
	var _absorbed_in = __webpack_require__(352);
	
	var _absorbed_in2 = _interopRequireDefault(_absorbed_in);
	
	var _Actionable = __webpack_require__(351);
	
	var _Actionable2 = _interopRequireDefault(_Actionable);
	
	var _confiqurable = __webpack_require__(359);
	
	var _confiqurable2 = _interopRequireDefault(_confiqurable);
	
	var _contextual = __webpack_require__(360);
	
	var _contextual2 = _interopRequireDefault(_contextual);
	
	var _extensible = __webpack_require__(361);
	
	var _extensible2 = _interopRequireDefault(_extensible);
	
	var _intelligent = __webpack_require__(365);
	
	var _intelligent2 = _interopRequireDefault(_intelligent);
	
	var _realtime = __webpack_require__(367);
	
	var _realtime2 = _interopRequireDefault(_realtime);
	
	var _ccd = __webpack_require__(358);
	
	var _ccd2 = _interopRequireDefault(_ccd);
	
	var _googlePlayBadge = __webpack_require__(356);
	
	var _googlePlayBadge2 = _interopRequireDefault(_googlePlayBadge);
	
	var _ic_manage_monitor = __webpack_require__(363);
	
	var _ic_manage_monitor2 = _interopRequireDefault(_ic_manage_monitor);
	
	var _ic_empower_engage = __webpack_require__(362);
	
	var _ic_empower_engage2 = _interopRequireDefault(_ic_empower_engage);
	
	var _ic_predict_prevent = __webpack_require__(364);
	
	var _ic_predict_prevent2 = _interopRequireDefault(_ic_predict_prevent);
	
	__webpack_require__(258);
	
	__webpack_require__(257);
	
	var _landingModule = __webpack_require__(251);
	
	var _landingModule2 = _interopRequireDefault(_landingModule);
	
	var _windowSize = __webpack_require__(371);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var settings = {
	  dots: false,
	  autoplay: true,
	  infinite: true,
	  speed: 400,
	  slidesToShow: 1,
	  slidesToScroll: 1
	};
	
	var LandingPage = function LandingPage() {
	  return _react2.default.createElement(
	    _react.Fragment,
	    null,
	    _react2.default.createElement(
	      'div',
	      { className: _landingModule2.default.landing__two__column__container },
	      _react2.default.createElement(
	        'div',
	        { className: _landingModule2.default.landing__two__column__container__box },
	        _react2.default.createElement(
	          _reactSlick2.default,
	          _extends({}, settings, { className: _landingModule2.default.slick__slider }),
	          _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	              'div',
	              { className: _landingModule2.default.landing__features__normal__subtitle },
	              'Organize field operations and',
	              _react2.default.createElement(
	                'span',
	                { className: _landingModule2.default.landing__features__highlighted__subtitle },
	                ' increase efficiency'
	              ),
	              '.'
	            ),
	            _react2.default.createElement('br', null),
	            _react2.default.createElement('br', null),
	            _react2.default.createElement(
	              'div',
	              { className: _landingModule2.default.landing__features__highlighted__title },
	              'UpTyme'
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: _landingModule2.default.landing__features__normal__title },
	              'Intelligent Field Automation'
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: _landingModule2.default.btn__wrapper },
	              _react2.default.createElement(
	                _gatsbyLink2.default,
	                { to: '/contactus', className: _landingModule2.default['landing__btn'] },
	                _react2.default.createElement(
	                  'span',
	                  null,
	                  'Want a trial?'
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	              'div',
	              { className: _landingModule2.default.landing__features__normal__subtitle },
	              'A',
	              _react2.default.createElement(
	                'span',
	                { className: _landingModule2.default.landing__features__highlighted__subtitle },
	                ' cloud based'
	              ),
	              ' mobility tool designed from the ground up for organizations with field or store execution teams.'
	            ),
	            _react2.default.createElement('br', null),
	            _react2.default.createElement('br', null),
	            _react2.default.createElement(
	              'div',
	              { className: _landingModule2.default.landing__features__highlighted__title },
	              'UpTyme'
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: _landingModule2.default.landing__features__normal__title },
	              'Intelligent Field Automation'
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: _landingModule2.default.btn__wrapper },
	              _react2.default.createElement(
	                _gatsbyLink2.default,
	                { to: '/contactus', className: _landingModule2.default['landing__btn'] },
	                _react2.default.createElement(
	                  'span',
	                  null,
	                  'Want a trial?'
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	              'div',
	              { className: _landingModule2.default.landing__features__normal__subtitle },
	              _react2.default.createElement(
	                'span',
	                { className: _landingModule2.default.landing__features__highlighted__subtitle },
	                'Analytical insights'
	              ),
	              ' and consulting designed to drive organizational ',
	              _react2.default.createElement(
	                'span',
	                { className: _landingModule2.default.landing__features__highlighted__subtitle },
	                ' optimization '
	              ),
	              ' and ',
	              _react2.default.createElement(
	                'span',
	                { className: _landingModule2.default.landing__features__highlighted__subtitle },
	                'visibility'
	              ),
	              '.'
	            ),
	            _react2.default.createElement('br', null),
	            _react2.default.createElement('br', null),
	            _react2.default.createElement(
	              'div',
	              { className: _landingModule2.default.landing__features__highlighted__title },
	              'UpTyme'
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: _landingModule2.default.landing__features__normal__title },
	              'Intelligent Field Automation'
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: _landingModule2.default.btn__wrapper },
	              _react2.default.createElement(
	                _gatsbyLink2.default,
	                { to: '/contactus', className: _landingModule2.default['landing__btn'] },
	                _react2.default.createElement(
	                  'span',
	                  null,
	                  'Want a trial?'
	                )
	              )
	            )
	          )
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: _landingModule2.default.landing__two__column__container__box },
	        _react2.default.createElement('img', { src: _absorbed_in2.default, className: _landingModule2.default.Absorbed })
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: _landingModule2.default.landing__three__column__container },
	      _react2.default.createElement(
	        'div',
	        { className: _landingModule2.default.landing__two__column__container__fullrow },
	        _react2.default.createElement(
	          'div',
	          { className: _landingModule2.default.landing__features__highlighted__title__center },
	          'UpTyme'
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: _landingModule2.default.landing__features__normal__subtitle_center },
	          'A seamless AI-enabled field automation platform that ensures continuous business uptime'
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: _landingModule2.default.landing__three__column__container__box_for_overview_with_shadow_1 },
	        _react2.default.createElement('img', { src: _ic_manage_monitor2.default, className: _landingModule2.default.Absorbed_head }),
	        _react2.default.createElement(
	          'div',
	          { style: { height: "100%" } },
	          _react2.default.createElement(
	            'div',
	            { className: _landingModule2.default.landing__features__highlighted__text_center_key },
	            'Manage and monitor'
	          ),
	          _react2.default.createElement('br', null),
	          _react2.default.createElement(
	            'div',
	            { className: _landingModule2.default.landing__features__normal__text_center_key },
	            'Our cloud based platform allows users to create and manage tasks from anywhere using any device.'
	          )
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: _landingModule2.default.landing__three__column__container__box_for_overview_with_shadow_2 },
	        _react2.default.createElement('img', { src: _ic_empower_engage2.default, className: _landingModule2.default.Absorbed_head }),
	        _react2.default.createElement(
	          'div',
	          { style: { height: "100%" } },
	          _react2.default.createElement(
	            'div',
	            { className: _landingModule2.default.landing__features__highlighted__text_center_key },
	            'Empower and engage'
	          ),
	          _react2.default.createElement('br', null),
	          _react2.default.createElement(
	            'div',
	            { className: _landingModule2.default.landing__features__normal__text_center_key },
	            'From knowledge sharing to real-time tracking, our intuitive mobile app works on any device. Data driven algorithms ensure optimal task assignment.'
	          )
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: _landingModule2.default.landing__three__column__container__box_for_overview_with_shadow_3 },
	        _react2.default.createElement('img', { src: _ic_predict_prevent2.default, className: _landingModule2.default.Absorbed_head }),
	        _react2.default.createElement(
	          'div',
	          { style: { height: "100%" } },
	          _react2.default.createElement(
	            'div',
	            { className: _landingModule2.default.landing__features__highlighted__text_center_key },
	            'Predict and prevent'
	          ),
	          _react2.default.createElement('br', null),
	          _react2.default.createElement(
	            'div',
	            { className: _landingModule2.default.landing__features__normal__text_center_key },
	            'Seamless IoT integration and machine learning to efficiently predict failures'
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: _landingModule2.default.landing__three__column__container },
	      _react2.default.createElement(
	        'div',
	        { className: _landingModule2.default.landing__two__column__container__fullrow },
	        _react2.default.createElement(
	          'div',
	          { className: _landingModule2.default.landing__features__highlighted__title__center },
	          'Key Principles'
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: _landingModule2.default.landing__three__column__container__box_with_shadow },
	        _react2.default.createElement('img', { src: _intelligent2.default, className: _landingModule2.default.Absorbed_key }),
	        _react2.default.createElement(
	          'div',
	          { style: { height: "100%" } },
	          _react2.default.createElement(
	            'div',
	            { className: _landingModule2.default.landing__features__highlighted__text_center },
	            'Intelligent'
	          ),
	          _react2.default.createElement('br', null),
	          _react2.default.createElement(
	            'div',
	            { className: _landingModule2.default.landing__features__normal__text_center },
	            'Algo driven intelligent recommendations on scheduling and assignment'
	          )
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: _landingModule2.default.landing__three__column__container__box_with_shadow },
	        _react2.default.createElement('img', { src: _Actionable2.default, className: _landingModule2.default.Absorbed_key }),
	        _react2.default.createElement(
	          'div',
	          { style: { height: "100%" } },
	          _react2.default.createElement(
	            'div',
	            { className: _landingModule2.default.landing__features__highlighted__text_center },
	            'Actionable'
	          ),
	          _react2.default.createElement('br', null),
	          _react2.default.createElement(
	            'div',
	            { className: _landingModule2.default.landing__features__normal__text_center },
	            'Realtime reporting & analytics that churn out insights on historical trends and predictions'
	          )
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: _landingModule2.default.landing__three__column__container__box_with_shadow },
	        _react2.default.createElement('img', { src: _confiqurable2.default, className: _landingModule2.default.Absorbed_key }),
	        _react2.default.createElement(
	          'div',
	          { style: { height: "100%" } },
	          _react2.default.createElement(
	            'div',
	            { className: _landingModule2.default.landing__features__highlighted__text_center },
	            'Configurable'
	          ),
	          _react2.default.createElement('br', null),
	          _react2.default.createElement(
	            'div',
	            { className: _landingModule2.default.landing__features__normal__text_center },
	            'Workflows are intuitively configurable using simple drag-and-drops or filters'
	          )
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: _landingModule2.default.landing__three__column__container__box_with_shadow },
	        _react2.default.createElement('img', { src: _contextual2.default, className: _landingModule2.default.Absorbed_key }),
	        _react2.default.createElement(
	          'div',
	          { style: { height: "100%" } },
	          _react2.default.createElement(
	            'div',
	            { className: _landingModule2.default.landing__features__highlighted__text_center },
	            'Contextual'
	          ),
	          _react2.default.createElement('br', null),
	          _react2.default.createElement(
	            'div',
	            { className: _landingModule2.default.landing__features__normal__text_center },
	            'Designed to be field user friendly; comes with multi-lingual support.'
	          )
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: _landingModule2.default.landing__three__column__container__box_with_shadow },
	        _react2.default.createElement('img', { src: _extensible2.default, className: _landingModule2.default.Absorbed_key }),
	        _react2.default.createElement(
	          'div',
	          { style: { height: "100%" } },
	          _react2.default.createElement(
	            'div',
	            { className: _landingModule2.default.landing__features__highlighted__text_center },
	            'Extensible'
	          ),
	          _react2.default.createElement('br', null),
	          _react2.default.createElement(
	            'div',
	            { className: _landingModule2.default.landing__features__normal__text_center },
	            'Plug-and-play integrations with existing CRM/ticket management systems.'
	          )
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: _landingModule2.default.landing__three__column__container__box_with_shadow },
	        _react2.default.createElement('img', { src: _realtime2.default, className: _landingModule2.default.Absorbed_key }),
	        _react2.default.createElement(
	          'div',
	          { style: { height: "100%" } },
	          _react2.default.createElement(
	            'div',
	            { className: _landingModule2.default.landing__features__highlighted__text_center },
	            'Real-time'
	          ),
	          _react2.default.createElement('br', null),
	          _react2.default.createElement(
	            'div',
	            { className: _landingModule2.default.landing__features__normal__text_center },
	            'Smart, location driven real-time team tracking and ticket closure'
	          )
	        )
	      )
	    ),
	    _react2.default.createElement('br', null),
	    _react2.default.createElement(
	      'div',
	      { className: _landingModule2.default.landing_client },
	      _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'div',
	          { className: _landingModule2.default.landing__features__highlighted__title__center },
	          'Our Clients'
	        ),
	        _react2.default.createElement('br', null),
	        _react2.default.createElement(
	          'a',
	          { href: 'https://www.cafecoffeeday.com/', target: '_blank' },
	          _react2.default.createElement('img', { src: _ccd2.default, className: _landingModule2.default.Absorbed_client })
	        )
	      )
	    ),
	    _react2.default.createElement('br', null),
	    _react2.default.createElement('br', null),
	    _react2.default.createElement(
	      'div',
	      { className: _landingModule2.default.landing__two__column__container },
	      _react2.default.createElement(
	        'div',
	        { className: _landingModule2.default.landing__hero__container__heading },
	        'Get started today'
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: _landingModule2.default.btn__wrapper },
	        _react2.default.createElement(
	          _gatsbyLink2.default,
	          { to: '/contactus', className: _landingModule2.default['landing__btn'] },
	          _react2.default.createElement(
	            'span',
	            null,
	            'Request Demo'
	          )
	        )
	      )
	    )
	  );
	};
	
	exports.default = LandingPage;
	module.exports = exports['default'];

/***/ }),

/***/ 251:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"slick__slider":"src-pages----landing-module---slick__slider---PsqYo","uptyme__logo":"src-pages----landing-module---uptyme__logo---3lPym","landing":"src-pages----landing-module---landing---1T43_","landing_client":"src-pages----landing-module---landing_client---2Zmma","Absorbed":"src-pages----landing-module---Absorbed---3ME3A","Absorbed_client":"src-pages----landing-module---Absorbed_client---1kQqu","Absorbed_key":"src-pages----landing-module---Absorbed_key---2mv-2","Absorbed_head":"src-pages----landing-module---Absorbed_head---2bVZU","landing__three__column__container":"src-pages----landing-module---landing__three__column__container---3IUJP","landing__three__column__container__box":"src-pages----landing-module---landing__three__column__container__box---DFLNJ","landing__three__column__container__box_with_shadow":"src-pages----landing-module---landing__three__column__container__box_with_shadow---3gSfz","landing__three__column__container__box_for_overview_with_shadow":"src-pages----landing-module---landing__three__column__container__box_for_overview_with_shadow---3iW_m","landing__three__column__container__box_for_overview_with_shadow_1":"src-pages----landing-module---landing__three__column__container__box_for_overview_with_shadow_1---2EB0g","landing__three__column__container__box_for_overview_with_shadow_2":"src-pages----landing-module---landing__three__column__container__box_for_overview_with_shadow_2---2kbds","landing__three__column__container__box_for_overview_with_shadow_3":"src-pages----landing-module---landing__three__column__container__box_for_overview_with_shadow_3---3YMRz","landing__two__column__container_grey":"src-pages----landing-module---landing__two__column__container_grey---1DAoY","landing__two__column__container":"src-pages----landing-module---landing__two__column__container---2FahE","landing__two__column_badge":"src-pages----landing-module---landing__two__column_badge---2XPTt","landing__two__column__badge__container__box":"src-pages----landing-module---landing__two__column__badge__container__box---1VZkt","landing__two__column__container__box":"src-pages----landing-module---landing__two__column__container__box---2e-23","landing__two__column__container__fullrow":"src-pages----landing-module---landing__two__column__container__fullrow---Phirt","landing__features__normal__text_center":"src-pages----landing-module---landing__features__normal__text_center---3peSx","landing__features__highlighted__text_center":"src-pages----landing-module---landing__features__highlighted__text_center---D76QS","landing__features__normal__text_center_key":"src-pages----landing-module---landing__features__normal__text_center_key---2_lwy","landing__features__highlighted__text_center_key":"src-pages----landing-module---landing__features__highlighted__text_center_key---2lA1i","landing__features__normal__text":"src-pages----landing-module---landing__features__normal__text---3XZoE","landing__features__highlighted__text":"src-pages----landing-module---landing__features__highlighted__text---L3nlw","landing__features__normal__subtitle":"src-pages----landing-module---landing__features__normal__subtitle---3wY7I","landing__features__highlighted__subtitle":"src-pages----landing-module---landing__features__highlighted__subtitle---z9ix2","landing__features__normal__subtitle_center":"src-pages----landing-module---landing__features__normal__subtitle_center---29f71","landing__features__highlighted__subtitle_center":"src-pages----landing-module---landing__features__highlighted__subtitle_center---2YByj","landing__features__normal__title":"src-pages----landing-module---landing__features__normal__title---3GuLL","landing__features__highlighted__title":"src-pages----landing-module---landing__features__highlighted__title---1cxqs","landing__features__normal__title__center":"src-pages----landing-module---landing__features__normal__title__center---1fxj-","landing__features__highlighted__title__center":"src-pages----landing-module---landing__features__highlighted__title__center---1bPBN","landing__hero__container":"src-pages----landing-module---landing__hero__container---faTmy","landing__hero__container__heading":"src-pages----landing-module---landing__hero__container__heading---Z5fQN","landing__hero__box":"src-pages----landing-module---landing__hero__box---qS3nE","landing__hero__header":"src-pages----landing-module---landing__hero__header---2Giiw","landing__hero__contents":"src-pages----landing-module---landing__hero__contents---1c_Gd","landing__header":"src-pages----landing-module---landing__header---160Ei","btn__wrapper":"src-pages----landing-module---btn__wrapper---HNJ4r","landing__btn":"src-pages----landing-module---landing__btn---3l1u1"};

/***/ }),

/***/ 351:
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ 352:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/absorbed_in.c86a87e7.png";

/***/ }),

/***/ 356:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/google-play-badge.db9b21a1.png";

/***/ }),

/***/ 358:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/ccd.02a40040.png";

/***/ }),

/***/ 359:
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PHN2ZyBpZD0iTGF5ZXJfMSIgZGF0YS1uYW1lPSJMYXllciAxIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxNDAgMTM5Ljc1Ij48ZGVmcz48c3R5bGU+LmNscy0xLC5jbHMtMntmaWxsOiMwMDJjYWU7fS5jbHMtMntzdHJva2U6I2ZmZjtzdHJva2UtbWl0ZXJsaW1pdDoxMDtzdHJva2Utd2lkdGg6M3B4O308L3N0eWxlPjwvZGVmcz48dGl0bGU+YWN0aW9uYWJsZTwvdGl0bGU+PHJlY3QgY2xhc3M9ImNscy0xIiB4PSIzNi40NSIgeT0iMjEiIHdpZHRoPSI2LjY0IiBoZWlnaHQ9IjkwIiByeD0iMy4zMiIvPjxjaXJjbGUgY2xhc3M9ImNscy0yIiBjeD0iNDAiIGN5PSI3MS4zNSIgcj0iMTEuMDEiLz48cmVjdCBjbGFzcz0iY2xzLTEiIHg9IjY4LjQzIiB5PSIyMSIgd2lkdGg9IjYuNjQiIGhlaWdodD0iOTAiIHJ4PSIzLjMyIi8+PGNpcmNsZSBjbGFzcz0iY2xzLTIiIGN4PSI3MS45OCIgY3k9IjQ5LjIzIiByPSIxMS4wMSIvPjxyZWN0IGNsYXNzPSJjbHMtMSIgeD0iOTguNDgiIHk9IjIxIiB3aWR0aD0iNi42NCIgaGVpZ2h0PSI5MCIgcng9IjMuMzIiLz48Y2lyY2xlIGNsYXNzPSJjbHMtMiIgY3g9IjEwMi4wMyIgY3k9IjgyLjY5IiByPSIxMS4wMSIvPjwvc3ZnPg=="

/***/ }),

/***/ 360:
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ 361:
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PHN2ZyBpZD0iTGF5ZXJfMSIgZGF0YS1uYW1lPSJMYXllciAxIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxNDAgMTM5Ljc1Ij48ZGVmcz48c3R5bGU+LmNscy0xe2ZpbGw6IzAwMmNhZTt9PC9zdHlsZT48L2RlZnM+PHRpdGxlPmFjdGlvbmFibGU8L3RpdGxlPjxwYXRoIGNsYXNzPSJjbHMtMSIgZD0iTTEwNy44Niw2NC41M1Y0Ni43OUg5NS43MlYyMS4zM2E2LjQ4LDYuNDgsMCwxLDAtMTMsMFY0Ni43OUg1OC40NVYyMS4zM2E2LjQ4LDYuNDgsMCwwLDAtMTMsMFY0Ni43OUgzMi4xNFY2NC41M0gzN1Y3OC44NWEzMy42NSwzMy42NSwwLDAsMCwyNS44NCwzMi42OXY5LjY2aDE1LjV2LTkuNjZBMzMuNjYsMzMuNjYsMCwwLDAsMTA0LjIsNzguODZWNjQuNTNaTTg5LjI1LDE5LjE2YTIuMTcsMi4xNywwLDAsMSwyLjE3LDIuMTdWMzMuNDFIODcuMDhWMjEuMzNBMi4xNywyLjE3LDAsMCwxLDg5LjI1LDE5LjE2Wk04Ny4wOCwzNy43Mmg0LjM0djkuMDdIODcuMDhaTTUyLDE5LjE2YTIuMTcsMi4xNywwLDAsMSwyLjE3LDIuMTdWMzMuNDFINDkuOFYyMS4zM0EyLjE3LDIuMTcsMCwwLDEsNTIsMTkuMTZaTTQ5LjgsMzcuNzJoNC4zNHY5LjA3SDQ5LjhaTTM2LjQ0LDYwLjIyVjUxLjFoNjcuMTF2OS4xMkgzNi40NFptMzcuNjEsNTYuNjdINjcuMTd2LTQuNjJjLjcyLjA4LDEuNDUuMTIsMi4xOS4xNXMxLjY1LDAsMi40OCwwLDEuNDgtLjA3LDIuMjEtLjE1Wm0yNS44NC0zOGEyOS4zNCwyOS4zNCwwLDAsMS0yMy4xLDI4LjYzbC0xLC4xN2MtLjkyLjE3LTEuOC4yOS0yLjY1LjM3bC0uMzIsMC0uNzgsMGMtLjQ5LDAtMSwwLTEuNDYsMHMtMSwwLTEuNDYsMGwtLjc5LDAtLjMxLDBjLS44Ni0uMDgtMS43My0uMi0yLjY2LS4zN2wtMS0uMTdhMjkuMzQsMjkuMzQsMCwwLDEtMjMuMS0yOC42M1Y2NC41M0g5OS44OVoiLz48cGF0aCBjbGFzcz0iY2xzLTEiIGQ9Ik03MC42MSw4OC40OUE4LjU3LDguNTcsMCwxLDAsNjIsNzkuOTIsOC41Nyw4LjU3LDAsMCwwLDcwLjYxLDg4LjQ5Wm0wLTEyLjgyYTQuMjYsNC4yNiwwLDEsMS00LjI2LDQuMjVBNC4yNiw0LjI2LDAsMCwxLDcwLjYxLDc1LjY3WiIvPjwvc3ZnPg=="

/***/ }),

/***/ 362:
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ 363:
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ 364:
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ 365:
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ 367:
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,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"

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-landing-js-63ed8ac95138b1457103.js